/*
  ══════════════════════════════════════════════════════════════════════════
  Cohort: student form — behaviour
  ══════════════════════════════════════════════════════════════════════════

  Moved out of sections/cohort-student-form.liquid on 2026-08-20, because
  that file had reached 261 KB against a hard Shopify limit of 256 KB per
  Liquid file and would no longer save. Two thirds of it was this script.

  Assets are not held to that limit — cohort-admin-form.js is over 500 KB —
  and this is the third file in the project to make the same move, after
  cohort-admin-form.js and cohort-status.js.

  ── What stayed behind, and why ───────────────────────────────────────────

  Liquid does not run inside an asset. Everything the section knows and this
  file needs is therefore written to window by the section, immediately
  before this file is loaded:

    window.COHORT_STUDENT_COHORTS         cohorts, products, deadlines
    window.COHORT_STUDENT_SCHOOLS         schools and their shop links
    window.COHORT_LATE_RESUBMIT_BY_TOKEN  late-round deadlines by token
    window.COHORT_STUDENT_SETTINGS        the three section settings

  Load order matters and is not incidental: the section writes those four,
  then loads this file. Moving the script tag above them would leave every
  one of them undefined and the form would open on an empty cohort list.
*/
(function() {
    /*
      The three values the section owns. They cannot travel in this file —
      an asset is served as plain JavaScript and Liquid never runs in it —
      so the section writes them and this reads them by name.
    */
    var SECTION_SETTINGS = window.COHORT_STUDENT_SETTINGS || {};
    var EMBEDDED_COHORTS = window.COHORT_STUDENT_COHORTS || [];
    var EMBEDDED_SCHOOLS = window.COHORT_STUDENT_SCHOOLS || [];
    var LATE_RESUBMIT_BY_TOKEN = window.COHORT_LATE_RESUBMIT_BY_TOKEN || {};
    var STUDENT_SUBMIT_WEBHOOK_URL = SECTION_SETTINGS.submitWebhookUrl || '';
    var SUBMISSION_LOCKS_CACHE_URL = SECTION_SETTINGS.locksCacheUrl || '';
    /* 2026-10-06 - the end dates of free-shipping codes, see fetchFreeShippingEnd. */
    var FREE_SHIPPING_CACHE_URL = SECTION_SETTINGS.freeShippingCacheUrl || '';
    /* 2026-10-06 - "Ask to be added", see sendJoinRequest. Empty hides the button. */
    var JOIN_REQUEST_WEBHOOK_URL = SECTION_SETTINGS.joinRequestWebhookUrl || '';
    var DEFAULT_STUDENT_STORE_URL = SECTION_SETTINGS.defaultStoreUrl || '';

    /*
      ── Размеры, которых студент не увидит — 2026-08-28 (владелица) ─────────

      Настройка секции, через запятую. Понадобилась, когда выяснилось, что
      список размеров у когорты заморожен: он попал в снимок в момент её
      создания, и правка каталога до открытой когорты не доходит — ни сток, ни
      галочка «continue selling», ни удаление варианта.

      Это фильтр показа и ничего больше. Он не трогает ни снимок, ни записи
      студентов, поэтому не может испортить цену в счёте школе — той цены он
      просто не касается. И он не мешает оплатить тому, кто размер уже выбрал:
      его выбор лежит в записи, а фильтр работает над списком, из которого
      выбирают.

      Пустая настройка означает поведение ровно такое, каким оно было до этой
      правки: список ниже пуст, и проверка вырождается в «ничего не прятать».

      Область — весь магазин, не когорта. Сегодня 2XS не нужен никому; если
      однажды одной школе он понадобится, а другой нет, этого будет мало и
      придётся возвращаться к снимку. Сказано здесь, чтобы через полгода это
      не выглядело недосмотром.
    */
    var HIDDEN_SIZES = String(SECTION_SETTINGS.hiddenSizes || '')
      .split(',')
      .map(function(size) { return size.trim().toLowerCase(); })
      .filter(function(size) { return size.length > 0; });

    /*
      Сравнение по названию варианта, приведённому к нижнему регистру и без
      пробелов по краям: «2XS», «2xs» и « 2XS » должны значить одно и то же.
      Владелица вписывает это руками, и требовать от неё точного регистра
      значило бы завести ошибку, которую не видно.
    */
    function isHiddenSize(variant) {
      if (!HIDDEN_SIZES.length) return false;

      var title = String((variant && variant.title) || '').trim().toLowerCase();
      if (!title) return false;

      return HIDDEN_SIZES.indexOf(title) !== -1;
    }

    var ACTIVE_COHORT = null;
    var currentStep = 1;
    var URL_TOKEN = '';
    var initParams = null;
    var SHIPPING_REQUIRED = false;
    /* 2026-10-08 - true when the cohort ships to students' homes (see
       configureDeliveryMode). The form has no address step since 2026-10-06. */
    var AVAILABLE_STEPS = [1, 3, 4];
    var submissionLocked = false;
    /* '', 'paid' or 'unpaid' — see refreshReturningPaymentState. */
    var returningPaymentState = '';
    /*
      2026-08-16, edit B — set once the status check has come back with no
      answer at all, or failed outright. Distinct from returningPaymentState
      staying '': that is also the value before the check has had time to run,
      and the two must not look alike on screen.
    */
    var returningPaymentCheckFailed = false;
    /*
      2026-10-07 - the wait for the payment answer, shown (owner).

      The panel used to be drawn at once with wording true "whatever the
      answer", then redrawn when the answer came - a student who had paid read
      "Not paid for delivery yet?" first. Now the panel is a loader until the
      answer is in, and the answer is shown no sooner than LOADER_MIN_MS after
      the loader appeared, together with everything it carries (the
      free-shipping code and its date), so nothing arrives in pieces.
    */
    var RETURNING_LOADER_MIN_MS = 5000;
    var returningLoaderStartedAt = 0;
    var returningLoaderTimer = null;
    var freeShipEndPromise = null;
    var RETURNING_LOADER_LINES = [
      'Checking your email…',
      'Looking up your order…',
      'Checking your delivery payment…',
      'Getting your free-shipping code ready…',
      'Almost there — this takes just a moment…'
    ];
    var emailNoticeRequestId = 0;
    var rosterHintDebounceTimer = null;
    var continueCheckInFlight = false;
    var EMAIL_CHECK_WAIT_TEXT = 'Please wait… we are checking your email.';
    var emailRosterUnmatched = false;
    /* Which campus this student attends — see getCohortCampuses (phase 4). */
    var selectedStudentCampus = '';
    /* Which program they are in — see getCohortPrograms (2026-10-05). */
    var selectedStudentProgram = '';
    /*
      2026-08-10 — the typed address already belongs to another student of this
      cohort. Not the same thing as "not on the approved list": that one is
      allowed and only worth a hint, this one is refused, because writing it
      would overwrite the classmate who owns the address.
    */
    var emailTaken = false;
    /* Sentinel, never shown: renderEmailTakenNotice has already said it
       properly next to the field, and the catch below prints raw messages. */
    var EMAIL_TAKEN_ERROR = '__email_taken__';
    /*
      2026-08-12 — the request never reached the server at all.

      Told apart from every other failure on purpose. "Failed to fetch" is the
      browser's own words for a request that did not complete, and until now it
      was printed to the student as-is: a technical English phrase that says
      nothing about the only thing they care about — whether their sizes were
      saved. Worse, it is not even an answer: a request can land and run while
      the reply is lost on the way back, so the form was calling a possible
      success a failure.
    */
    var NETWORK_ERROR = '__network_error__';
    var NETWORK_ERROR_MESSAGE = 'We couldn\'t reach the server. Check your internet connection and press Submit Sizes again — your answers are still here.';

    function normalizeSchoolKey(value) {
      return String(value || '').trim().toUpperCase();
    }

    function findSchoolByCode(schoolCode) {
      var normalized = normalizeSchoolKey(schoolCode);
      if (!normalized) return null;

      return EMBEDDED_SCHOOLS.find(function(school) {
        return normalizeSchoolKey(school.schoolCode) === normalized ||
          normalizeSchoolKey(school.schoolHandle) === normalized;
      }) || null;
    }

    function resolveStudentStoreUrl(cohort) {
      var school = cohort ? findSchoolByCode(cohort.schoolCode) : null;
      var url = school && school.studentStoreUrl ? String(school.studentStoreUrl).trim() : '';

      if (!url) {
        url = String(DEFAULT_STUDENT_STORE_URL || '').trim();
      }

      return url;
    }

    function applyStudentStoreLink(cohort) {
      var storeLink = document.getElementById('success-store-link');
      var storeCard = storeLink ? storeLink.closest('.success-next-step-card') : null;
      var storeHero = storeLink ? storeLink.closest('.success-store-hero') : null;
      var url = resolveStudentStoreUrl(cohort);

      if (storeLink && url) {
        storeLink.href = url;
      }

      /*
        Phase 8 (2026-08-12) — hidden where the student pays for delivery.

        Two reasons, and the first one matters more. This card says "Your
        school order is complete", which stopped being true: their place is
        held only once the delivery payment goes through, and telling them it
        is done is how somebody walks away from a delivery they still owe. The
        second is plainer — the payment panel already carries its own note
        (renderExtraSetOffer), so this would be a second door to the same room.

        Untouched for school-delivery cohorts, where the order really is
        complete when the form is in.
      */
      var hideForPayment = studentPaysForDelivery();
      /* 2026-10-16 (owner): never on a demo cohort - the extra set leads to
         the real shop, and the demo has nothing to buy. */
      var shouldShow = url && !hideForPayment && !isDemoCohort();

      if (storeCard) {
        storeCard.style.display = shouldShow ? '' : 'none';
      }

      /* The wrapper carries its own spacing, so leaving it behind would leave
         a gap where the card used to be. */
      if (storeHero) {
        storeHero.style.display = shouldShow ? '' : 'none';
      }
    }

    function esc(value) {
      return String(value || '').replace(/[&<>"']/g, function(match) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        }[match];
      });
    }

    function normalizeCode(value) {
      return String(value || '')
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9-]/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    }

    function normalizeCodeLoose(value) {
      return normalizeCode(value).replace(/[^A-Z0-9]/g, '');
    }

    function normalizeEmail(value) {
      return String(value || '').trim().toLowerCase();
    }

    function isValidEmail(value) {
      return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(String(value || '').trim());
    }

    function getLocalRosterMatch(email) {
      if (!ACTIVE_COHORT) {
        return null;
      }

      var roster = ACTIVE_COHORT.rosterEmails;

      if (!Array.isArray(roster) || roster.length === 0) {
        return null;
      }

      return roster.indexOf(normalizeEmail(email)) !== -1;
    }

    function applyRosterHintForEmail(email) {
      var localMatch = getLocalRosterMatch(email);

      if (localMatch === false) {
        hideAlreadySubmittedNotice();
        setEmailRosterUnmatched(true);
        return true;
      }

      if (localMatch === true) {
        setEmailRosterUnmatched(false);
        return true;
      }

      return false;
    }

    /*
      ── 2026-10-17 (owner) - a classmate's address on someone else's link ──

      A personal link carries a token built from the cohort code and the
      student's address (the rule the Mechanic tasks share - see
      submitStepZero). So the page can tell whose link it is: the address on
      the school's list whose token is the one in the link.

      If the address typed is another student of the same list, the link is
      not theirs, and the server would refuse the answers at the very end -
      quietly, since its refusal never reaches the browser (CLAUDE.md, trap
      3). The owner filled in a whole form that way and was told it was
      "taking longer than usual". Now it is stopped at the address, with no
      way past.

      Only when both are on the list. A token that matches no listed address
      (the one built to dodge a handle collision) and an address that is not
      on the list keep the old way out, "This is my link and my address":
      refusing a real student is the worse failure there.
    */
    var FOREIGN_LINK_TITLE = 'This link belongs to another student.';
    var FOREIGN_LINK_TEXT = 'Each student has a link of their own. Open the link from your own email, or ask your school admin to send it again.';

    function linkOwnerRosterEmail() {
      var urlToken = String(URL_TOKEN || '').trim();
      if (!urlToken || !ACTIVE_COHORT || !Array.isArray(ACTIVE_COHORT.rosterEmails)) return '';

      var codeHandle = handleizeLike(ACTIVE_COHORT.cohortCode);
      for (var i = 0; i < ACTIVE_COHORT.rosterEmails.length; i++) {
        var listed = normalizeEmail(ACTIVE_COHORT.rosterEmails[i]);
        if (listed && handleizeLike(codeHandle + '-' + listed) === urlToken) return listed;
      }
      return '';
    }

    function isClassmateOnForeignLink(email) {
      var typed = normalizeEmail(email);
      var owner = linkOwnerRosterEmail();
      return !!(owner && typed && typed !== owner && getLocalRosterMatch(typed) === true);
    }

    function parseJson(value, fallback) {
      if (Array.isArray(value) || (value && typeof value === 'object')) {
        return value;
      }

      try {
        return JSON.parse(value);
      } catch (error) {
        return fallback == null ? null : fallback;
      }
    }

    function normalizeOrderType(value) {
      var normalized = String(value || '').trim().toLowerCase();

      if (
        normalized === 'individual_student_orders' ||
        normalized === 'ship_to_students' ||
        normalized === 'individual_student_order'
      ) {
        return 'individual_student_orders';
      }

      return 'school_order';
    }

    function extractEmails(value) {
      var list = [];
      var seen = {};
      var parsed;
      var rawText;

      if (Array.isArray(value)) {
        parsed = value.slice();
      } else {
        rawText = String(value || '').trim();

        if (!rawText) {
          return [];
        }

        if (rawText.charAt(0) === '[') {
          try {
            parsed = JSON.parse(rawText);
          } catch (error) {
            parsed = rawText.split(/[\n,;]+/);
          }
        } else {
          parsed = rawText.split(/[\n,;]+/);
        }
      }

      (parsed || []).forEach(function(entry) {
        var email = normalizeEmail(entry);
        if (!email || !isValidEmail(email) || seen[email]) {
          return;
        }
        seen[email] = true;
        list.push(email);
      });

      return list;
    }

    function applyLateResubmitOverride(cohort, token) {
      if (!cohort || !token) return cohort;

      /*
        2026-09-14, owner: a late round's own date no longer closes anything,
        the same rule the main deadline has followed since 2026-08-02. Only
        finalization shuts a door.

        So the override applies whether or not its date has gone by. It has to:
        the round carries the delivery mode as well as the date, and a round
        that ships home would have quietly reverted to school delivery the
        morning after its deadline - the student would have filled the form in
        and nobody would have learned where the parcel was meant to go.
      */
      var override = LATE_RESUBMIT_BY_TOKEN[token];
      if (!override || !override.lateDeadline) {
        return cohort;
      }

      var next = Object.assign({}, cohort);
      next.deadline = override.lateDeadline;
      next.deadlineDisplay = override.lateDeadlineDisplay || override.lateDeadline;
      next.lateResubmitActive = true;

      if (String(override.deliveryMode || '').toLowerCase() === 'home_delivery') {
        next.deliveryMode = 'home_delivery';
        next.orderType = 'individual_student_orders';
        next.shipToStudents = true;
      }

      return next;
    }

    /*
      Main cohort deadline does NOT close the form by itself (owner decision,
      2026-08-02) — only actual finalization does (cohort.status flips to
      non-'open' asynchronously once cohort-capture-draft-order.liquid
      processes the draft order webhook, see CLAUDE.md's async webhook UX
      rules). The deadline is still shown as an informational notice
      (renderDeadline()) and still enforced separately for Late-batch resubmit
      links (override.lateDeadline below) — that's a distinct, intentional
      deadline that really does gate access to its own window.
    */
    function canOpenStudentForm(cohort, token) {
      if (!cohort) return false;

      /*
        A student inside a late round is inside it until the round is
        finalized, date or no date. Before 2026-09-14 a passed date fell
        through to the cohort check below, which meant the window closed for
        the students of a finalized cohort - the only ones a late round is
        ever opened for - and stayed open for everybody else. The rule now
        matches what it says on the tin, and it is the owner's rule for the
        main deadline applied here too.
      */
      var override = token ? LATE_RESUBMIT_BY_TOKEN[token] : null;
      if (override && override.lateDeadline) {
        return true;
      }

      if (cohort.status !== 'open') return false;
      return true;
    }

    function getLateResubmitBlockReason(cohort, token) {
      var override = token ? LATE_RESUBMIT_BY_TOKEN[token] : null;
      if (override && override.lateDeadline) {
        /* The round is open, so there is nothing to explain. */
        return null;
      }

      if (cohort.status !== 'open') {
        return {
          title: 'Cohort status is ' + cohort.status,
          message: 'This form is closed.'
        };
      }

      return null;
    }

    function normalizeEmbeddedCohort(source) {
      if (!source) return null;

      var products = parseJson(source.productsRaw || source.products || '[]', []);
      var deliveryMode = String(source.deliveryMode || source.delivery_mode || '').trim().toLowerCase();
      var orderType = normalizeOrderType(source.orderType || source.order_type);
      var shipToStudents = source.shipToStudents === true || source.shipToStudents === 'true';

      if (deliveryMode === 'home_delivery') {
        orderType = 'individual_student_orders';
        shipToStudents = true;
      } else if (deliveryMode === 'school_delivery') {
        orderType = 'school_order';
        shipToStudents = false;
      }

      return {
        cohortCode: normalizeCode(source.cohortCode || source.cohort_code || source.unique_code || source.code || ''),
        cohortId: normalizeCode(source.cohortId || source.cohort_id || source.cohortCode || source.code || ''),
        schoolName: String(source.schoolName || source.school_name || '').trim(),
        schoolCode: String(source.schoolCode || source.school_code || '').trim(),
        status: String(source.status || 'open').toLowerCase(),
        deadline: source.deadline || '',
        deadlineDisplay: source.deadlineDisplay || source.deadline_display || source.deadline || '',
        deliveryMode: deliveryMode,
        orderType: orderType,
        shipToStudents: shipToStudents,
        studentFormUrl: String(source.studentFormUrl || source.student_form_url || '').trim(),
        statusPageUrl: String(source.statusPageUrl || source.status_page_url || '').trim(),
        products: Array.isArray(products) ? products : [],
        rosterEmails: extractEmails(source.studentEmailsRaw || source.student_emails || '[]'),
        adminEmail: String(source.adminEmail || source.admin_email || '').trim()
      };
    }

    function findEmbeddedCohort(code) {
      var normalized = normalizeCode(code);
      var loose = normalizeCodeLoose(code);

      for (var i = 0; i < EMBEDDED_COHORTS.length; i += 1) {
        var cohort = normalizeEmbeddedCohort(EMBEDDED_COHORTS[i]);
        if (!cohort) continue;

        if (normalizeCode(cohort.cohortCode) === normalized || normalizeCodeLoose(cohort.cohortCode) === loose) {
          return cohort;
        }
      }

      return null;
    }

    function getDeadlineDate(deadlineValue, useEndOfDay) {
      if (!deadlineValue) return null;

      var raw = String(deadlineValue).trim();
      var dateOnlyMatch = raw.match(/^(\d{4}-\d{2}-\d{2})/);

      if (dateOnlyMatch) {
        var dateOnly = dateOnlyMatch[1];
        var localDate = new Date(dateOnly + (useEndOfDay ? 'T23:59:59' : 'T00:00:00'));
        if (!isNaN(localDate.getTime())) {
          return localDate;
        }
      }

      var parsed = new Date(raw);
      if (isNaN(parsed.getTime())) {
        return null;
      }

      return parsed;
    }

    /*
      isDeadlinePassed stood here until 2026-09-14. Its two callers were the
      late-round window, and both went when a round's date stopped closing
      anything - no deadline in this file gates access any more. Deleted with
      them rather than left looking useful: getDeadlineDate, which it wrapped,
      is still here and still used for showing dates.
    */

    function showInvalid(reason, message) {
      var invalidCard = document.getElementById('invalid-link');

      document.getElementById('loading-state').style.display = 'none';
      document.getElementById('form-container').style.display = 'none';

      /*
        2026-09-01 — and the email box, which was left standing (owner).

        Step one lives in its own card, outside form-container, so hiding the
        wizard left it on screen: a student who had just been told the form is
        closed still had a field asking for their address, with the refusal
        stacked underneath it. Two answers to one question, in the wrong
        order.
      */
      var verifyScreen = document.getElementById('link-verify-screen');
      if (verifyScreen) verifyScreen.style.display = 'none';

      invalidCard.style.display = 'block';

      var titleEl = document.getElementById('invalid-link-title');
      var isClosed = /closed|completed|archived|finalized|deadline passed/i.test(String(message || '') + ' ' + String(reason || ''));

      if (invalidCard) {
        invalidCard.classList.toggle('is-closed', isClosed);
      }

      if (titleEl) {
        titleEl.innerHTML = isClosed
          ? 'Form <span>closed</span>'
          : 'Invalid <span>link</span>';
      }

      if (message) {
        document.getElementById('invalid-link-text').textContent = message;
      }

      if (reason) {
        var debugElement = document.getElementById('debug-error');
        debugElement.style.display = 'block';
        debugElement.textContent = 'Debug: ' + reason;
      }
    }

    function renderDeadline() {
      var notice = document.getElementById('deadline-notice');

      if (!ACTIVE_COHORT || !ACTIVE_COHORT.deadline) {
        return;
      }

      var deadlineDate = getDeadlineDate(ACTIVE_COHORT.deadline, false);

      if (!deadlineDate) {
        return;
      }

      var formattedDate = deadlineDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });

      notice.innerHTML =
        '<div class="notice-icon">i</div>' +
        '<div class="notice-content">' +
          '<span class="notice-text">You must submit your sizes by</span>' +
          '<span class="notice-highlight">' + esc(formattedDate) + '</span>' +
        '</div>';

      notice.style.display = 'flex';
    }

    function renderEmailFormatErrorNotice(message) {
      var box = document.getElementById('email-error-notice');
      if (!box) return;

      box.innerHTML =
        '<div class="notice-icon">!</div>' +
        '<div class="notice-content">' +
          '<span class="notice-highlight">Invalid email.</span> ' +
          '<span class="notice-text">' + esc(message || 'Please enter a valid email address.') + '</span>' +
        '</div>';

      box.style.display = 'flex';
    }

    function renderEmailErrorNotice(message) {
      renderEmailFormatErrorNotice(message);
    }

    /*
      ── "Ask to be added" (2026-10-06, plan 4.3, the quick version) ─────────

      A student refused on step one can ask in one press instead of writing an
      email. The request goes to Cohort: Student Join Request, which writes to
      the cohort's admin and to support. Nothing is stored; the admin adds the
      student with Add students as usual.

      What the screen may claim: the webhook answering only means the request
      arrived (CLAUDE.md, "Asynchronous webhook UX rules"). So the words say it
      was sent, not that anyone has read it, and they tell the student what
      happens next. One press per email per page: the button stays disabled
      after it, and the task itself sends one letter per email per day.

      Remembered by email, because the notice is redrawn whenever the step
      changes and would otherwise forget it was answered.
    */
    var joinRequestState = { email: '', status: '' };

    function joinRequestActionsHtml() {
      if (!JOIN_REQUEST_WEBHOOK_URL) return '';

      var form = document.getElementById('student-form');
      var email = normalizeEmail(form && form.email ? form.email.value : '');
      var state = joinRequestState.email === email ? joinRequestState.status : '';

      var statusHtml = '';
      if (state === 'sent') {
        statusHtml = '<p class="join-request-status is-sent" role="status">Request sent. Your school admin will get an email. Once they add you, come back to this page and continue with the same email.</p>';
      } else if (state === 'failed') {
        statusHtml = '<p class="join-request-status" role="status">We couldn\'t send your request. Check your internet connection and try again.</p>';
      }

      var disabled = state === 'sending' || state === 'sent';
      var label = state === 'sending' ? 'Sending…' : (state === 'sent' ? 'Request sent' : 'Ask to be added');

      return '<div class="join-request-actions">' +
        '<button type="button" class="join-request-btn" data-join-request' + (disabled ? ' disabled' : '') + '>' + esc(label) + '</button>' +
        statusHtml +
      '</div>';
    }

    function sendJoinRequest() {
      var form = document.getElementById('student-form');
      if (!form || !ACTIVE_COHORT || !JOIN_REQUEST_WEBHOOK_URL) return;

      var email = normalizeEmail(form.email.value || '');
      if (!isValidEmail(email)) return;
      if (joinRequestState.email === email && (joinRequestState.status === 'sending' || joinRequestState.status === 'sent')) return;

      joinRequestState = { email: email, status: 'sending' };
      syncEmailRosterHintNotices();

      fetch(JOIN_REQUEST_WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'join_request',
          source: 'cohort_student_form',
          cohort_code: normalizeCode(ACTIVE_COHORT.cohortCode),
          email: email,
          first_name: String(form.first_name.value || '').trim(),
          last_name: String(form.last_name.value || '').trim(),
          student_id: String(form.student_id.value || '').trim(),
          phone: studentPhoneValue(form)
        })
      }).then(function(response) {
        joinRequestState = { email: email, status: response && response.ok ? 'sent' : 'failed' };
      }).catch(function() {
        joinRequestState = { email: email, status: 'failed' };
      }).then(function() {
        syncEmailRosterHintNotices();
      });
    }

    document.addEventListener('click', function(event) {
      var button = event.target && event.target.closest ? event.target.closest('[data-join-request]') : null;
      if (!button || button.disabled) return;
      event.preventDefault();
      sendJoinRequest();
    });

    /* The cohort's admin, when the cohort names one (2026-10-06, owner). */
    function rosterAdminContactHtml() {
      var adminEmail = ACTIVE_COHORT && ACTIVE_COHORT.adminEmail;
      if (!adminEmail || !isValidEmail(adminEmail)) return '';
      return ' at <a href="mailto:' + esc(adminEmail) + '">' + esc(adminEmail) + '</a>';
    }

    function getEmailRosterHintHtml() {
      return (
        '<div class="notice-content">' +
          /* 2026-10-06 - a refusal now, not a hint: see validateStep(1). */
          '<span class="notice-highlight">This email is not on your school\'s student list.</span> ' +
          '<span class="notice-text">Please use the email address your school has for you. ' +
          'If you think this is a mistake, ask your school admin to add you' +
          rosterAdminContactHtml() +
          ', or write to us at <a href="mailto:contact@apres-scrubs.com">contact@apres-scrubs.com</a>.' +
          '</span>' +
          joinRequestActionsHtml() +
        '</div>'
      );
    }

    function syncEmailRosterHintNotices() {
      var stepBox = document.getElementById('email-roster-hint-notice');
      var reviewBox = document.getElementById('email-roster-hint-notice-review');
      var html = getEmailRosterHintHtml();
      var shouldShow = emailRosterUnmatched && (currentStep === 1 || currentStep === 4);

      /* Step 0 shows the same refusal; keep its Ask to be added state current. */
      var stepZeroBox = document.getElementById('link-verify-error');
      if (stepZeroBox && stepZeroBox.getAttribute('data-roster-refusal') === '1' && !stepZeroBox.hidden) {
        stepZeroBox.innerHTML = html;
      }

      [stepBox, reviewBox].forEach(function(box) {
        if (!box) return;

        if (shouldShow && (box === stepBox ? currentStep === 1 : currentStep === 4)) {
          box.innerHTML = html;
          box.className = 'notice-box notice-roster-review';
          box.style.display = 'flex';
        } else {
          box.style.display = 'none';
          box.innerHTML = '';
          box.className = box.id === 'email-roster-hint-notice-review'
            ? 'notice-box notice-roster-review'
            : 'notice-box notice-roster-review';
        }
      });
    }

    function setEmailCheckLoading(loading) {
      var statusEl = document.getElementById('email-check-status');
      var nextButton = document.getElementById('next-btn');

      if (statusEl) {
        statusEl.textContent = loading ? EMAIL_CHECK_WAIT_TEXT : '';
        statusEl.classList.toggle('is-visible', !!loading);
        statusEl.setAttribute('aria-hidden', loading ? 'false' : 'true');
      }

      if (nextButton && currentStep === 1) {
        nextButton.classList.toggle('is-loading', !!loading);
        nextButton.disabled = !!submissionLocked || !!loading;
        nextButton.textContent = 'Continue';
      }
    }

    function setEmailRosterUnmatched(unmatched) {
      emailRosterUnmatched = !!unmatched;
      syncEmailRosterHintNotices();
    }

    function hideEmailRosterHintNotice() {
      emailRosterUnmatched = false;
      syncEmailRosterHintNotices();
    }

    function renderEmailRosterHintNotice() {
      setEmailRosterUnmatched(true);
    }

    function resolveEmailRosterUnmatched(cohortCode, email, pollOptions) {
      return fetchSubmissionState().then(function(state) {
        if (isSubmissionUnmatchedInState(state, cohortCode, email)) {
          return true;
        }

        if (!SUBMISSION_LOCKS_CACHE_URL || !STUDENT_SUBMIT_WEBHOOK_URL) {
          return false;
        }

        return triggerSubmissionStatusCheck({
          action: 'check_submission_status',
          source: 'cohort_student_form',
          cohort_code: normalizeCode(ACTIVE_COHORT.cohortCode),
          cohort_id: normalizeCode(ACTIVE_COHORT.cohortId || ACTIVE_COHORT.cohortCode),
          email: email,
          /* Same reason as buildStatusCheckPayload — see the note there. */
          token: URL_TOKEN
        }).then(function() {
          return pollSubmissionRosterHint(cohortCode, email, pollOptions);
        });
      }).catch(function() {
        return false;
      });
    }

    function refreshReviewRosterHint() {
      var form = document.getElementById('student-form');
      if (!form || !ACTIVE_COHORT || currentStep !== 4) {
        return Promise.resolve();
      }

      var email = normalizeEmail(form.email.value || '');
      if (!isValidEmail(email)) {
        hideEmailRosterHintNotice();
        return Promise.resolve();
      }

      if (applyRosterHintForEmail(email)) {
        return Promise.resolve();
      }

      if (!SUBMISSION_LOCKS_CACHE_URL || !STUDENT_SUBMIT_WEBHOOK_URL) {
        return Promise.resolve();
      }

      return resolveEmailRosterUnmatched(ACTIVE_COHORT.cohortCode, email, {
        maxAttempts: 12,
        intervalMs: 180,
        initialDelayMs: 80
      }).then(function(unmatched) {
        if (currentStep !== 4) {
          return;
        }

        setEmailRosterUnmatched(!!unmatched);
      });
    }

    function hideEmailErrorNotice() {
      var box = document.getElementById('email-error-notice');
      if (!box) return;
      box.style.display = 'none';
      box.innerHTML = '';
    }

    function hideAlreadySubmittedNotice() {
      var box = document.getElementById('already-submitted-notice');
      if (!box) return;
      box.style.display = 'none';
      box.innerHTML = '';
      submissionLocked = false;
      syncStepOneContinueButton();
    }

    /*
      2026-08-06 — was a notice above the email field. The wizard stayed on
      screen behind it, so a student who had already finished could carry on
      filling it in and only find out at the end — if at all, since the task's
      refusal never reaches this page. It is a screen now, in place of the form.
    */
    function renderAlreadySubmittedNotice(message) {
      submissionLocked = true;
      hideEmailRosterHintNotice();

      var text = document.getElementById('already-submitted-screen-text');
      if (text && message) {
        text.textContent = 'Your sizes are saved. ' + message;
      }

      showStudentStateScreen('already-submitted-screen');
      renderReturningStudentPayPanel();
      syncStepOneContinueButton();
      refreshReturningPaymentState();
    }

    /*
      Asks the server whether this student still owes for delivery, and redraws
      the panel when the answer comes back.

      Fire and forget: the panel is already on screen with wording that is true
      whatever the answer, so nothing waits on this and a failure changes
      nothing. Only for students who pay for their own delivery — nobody else
      has a payment to be told about.
    */
    function refreshReturningPaymentState() {
      if (!studentPaysForDelivery()) return;

      /*
        2026-08-28 — a check that cannot run is a check that failed.

        It used to return here in silence, which left the panel waiting for an
        answer that was never coming. That mattered little while the refill ran
        regardless; now that the refill waits for "unpaid", the difference
        between "still asking" and "cannot ask" is the difference between a
        student seeing a button and a student seeing nothing happen.
      */
      if (!SUBMISSION_LOCKS_CACHE_URL || !STUDENT_SUBMIT_WEBHOOK_URL) {
        returningPaymentCheckFailed = true;
        renderReturningStudentPayPanel();
        return;
      }

      /*
        The address the student typed at step 1 — the same one the status check
        asks about, so the two cannot disagree. Every path that reaches this
        screen has been through that field.
      */
      var form = document.getElementById('student-form');
      var cohortCode = (ACTIVE_COHORT && ACTIVE_COHORT.cohortCode) || '';
      var email = form ? normalizeEmail(form.email.value || '') : '';

      /* Same reasoning as above: nothing to ask with is not the same as
         waiting for an answer, and the panel has to be able to tell them
         apart now that the refill does. */
      if (!cohortCode || !email) {
        returningPaymentCheckFailed = true;
        renderReturningStudentPayPanel();
        return;
      }

      /* Asked now, so the date is ready when the answer is shown. */
      prefetchFreeShippingEnd();

      triggerSubmissionStatusCheck(buildStatusCheckPayload()).then(function() {
        return pollSubmissionFlags(cohortCode, email);
      }).then(function(flags) {
        return afterReturningLoader().then(function() { return flags; });
      }).then(function(flags) {
        var next = (flags && flags.payment) || '';

        if (next && next !== returningPaymentState) {
          returningPaymentState = next;
          renderReturningStudentPayPanel();
          return;
        }

        /*
          2026-08-16, edit B — the answer never arrived.

          Nothing is assumed from that: the student is not told they have paid.
          They are sent to their payment link, and the payment page itself says
          if it is already paid.
        */
        if (!next) {
          returningPaymentCheckFailed = true;
          renderReturningStudentPayPanel();
        }
      }).catch(function() {
        afterReturningLoader().then(function() {
          returningPaymentCheckFailed = true;
          renderReturningStudentPayPanel();
        });
      });
    }

    function prefetchFreeShippingEnd() {
      var code = studentFreeShippingCode();
      freeShipEndPromise = code ? fetchFreeShippingEnd(code) : Promise.resolve(null);
    }

    /* Resolves once the loader has been up for its minimum, and the code's
       date has been asked for (never waiting on it longer than 4 seconds). */
    function afterReturningLoader() {
      var started = returningLoaderStartedAt || Date.now();
      var wait = Math.max(0, started + RETURNING_LOADER_MIN_MS - Date.now());
      var minimum = new Promise(function(resolve) { setTimeout(resolve, wait); });
      var date = Promise.race([
        freeShipEndPromise || Promise.resolve(null),
        new Promise(function(resolve) { setTimeout(resolve, 4000); })
      ]);
      return Promise.all([minimum, date]);
    }

    function stopReturningLoader() {
      if (returningLoaderTimer) clearInterval(returningLoaderTimer);
      returningLoaderTimer = null;
    }

    function renderReturningLoader(kicker, title, text, actions, extra) {
      if (!returningLoaderStartedAt) returningLoaderStartedAt = Date.now();

      kicker.textContent = 'One moment';
      title.textContent = 'Checking your order';
      text.textContent = '';
      hideExtraSetOffer(extra);

      actions.innerHTML =
        '<div class="returning-loader" role="status" aria-live="polite">' +
          '<span class="returning-loader-orb" aria-hidden="true"></span>' +
          '<div class="returning-loader-bar" aria-hidden="true"><span></span></div>' +
          '<p class="returning-loader-text">' + esc(RETURNING_LOADER_LINES[0]) + '</p>' +
          '<p class="returning-loader-note">Please keep this page open — it only takes a few seconds.</p>' +
        '</div>';

      if (returningLoaderTimer) return;

      var index = 0;
      returningLoaderTimer = setInterval(function() {
        var line = document.querySelector('.returning-loader-text');
        if (!line) { stopReturningLoader(); return; }
        index = (index + 1) % RETURNING_LOADER_LINES.length;
        line.classList.add('is-fading');
        setTimeout(function() {
          line.textContent = RETURNING_LOADER_LINES[index];
          line.classList.remove('is-fading');
        }, 350);
      }, 1800);
    }

    /*
      A student who has already answered the form and pays for delivery.

      Paid: "Everything is done", their school store and the free-shipping
      code. Not paid, or the payment check could not answer: their own
      payment link (waitForCheckoutLink). The loader covers the wait for the
      payment check itself.
    */
    function renderReturningStudentPayPanel(prefix) {
      var base = prefix || 'already-submitted-cart';

      /* Whatever is drawn from here on belongs on this screen, not on the one
         a fresh submission would have used. */
      activeCartPanelBase = base;

      var panel = document.getElementById(base + '-panel');
      var kicker = document.getElementById(base + '-kicker');
      var title = document.getElementById(base + '-title');
      var text = document.getElementById(base + '-text');
      var actions = document.getElementById(base + '-actions');
      var extra = document.getElementById(base + '-extra');

      if (!panel || !kicker || !title || !text || !actions) return;

      if (!studentPaysForDelivery()) {
        panel.hidden = true;
        panel.setAttribute('aria-hidden', 'true');
        return;
      }

      /* No answer yet and none refused: the loader, not a guess. Only on the
         returning-student screen, which is the one that asks: the pending
         screen draws this panel without a check, and would wait forever. */
      if (base === 'already-submitted-cart' && !returningPaymentState && !returningPaymentCheckFailed) {
        renderReturningLoader(kicker, title, text, actions, extra);
        panel.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
        return;
      }

      stopReturningLoader();

      if (returningPaymentState === 'paid') {
        kicker.textContent = 'Delivery paid';
        title.textContent = 'Everything is done';
        text.textContent = 'Your sizes are saved and your delivery is paid for. There is nothing left to do — your uniform is on its way.';
        actions.innerHTML = '';

        /*
          2026-09-01 (owner) - a finished student is given somewhere to go:
          their own school store, from the School record with the shop-wide
          setting behind it. An anchor, not a button that fetches. No address
          configured, no button - a full stop rather than a broken link.
        */
        var paidStoreUrl = resolveStudentStoreUrl(ACTIVE_COHORT);

        if (paidStoreUrl) {
          actions.innerHTML =
            '<a class="success-cart-btn hero" href="' + esc(paidStoreUrl) + '">' +
              'Go to my school store' +
            '</a>';
        }

        renderFreeShippingCode(extra);
        panel.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
        return;
      }

      /*
        2026-10-07 - a student who has not paid is sent to their own payment
        link, never to a cart (owner: "you have filled in the form - go to the
        link to pay for delivery"). The status check that brought them here
        also asks for the link if they have none, so it may still be on its
        way: waitForCheckoutLink waits for it. A failed payment check lands
        here too - the payment page itself says if it is already paid.

        The cart path that used to follow (put the uniform back in an empty
        cart from the link's items) was removed on 2026-10-08, owner approved;
        docs/archive/cart-checkout-2026-10 holds it.
      */
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      waitForCheckoutLink({
        title: 'Getting your payment link',
        kicker: 'Form completed',
        intro: 'You have filled in the form. Press the button to pay for delivery — your school pays for the uniform, and you will enter your address and phone number on the payment page. The phone number lets the delivery service reach you if there is a problem.'
      });
    }

    /*
      ── The payment link's screen ─────────────────────────────────────────

      The address is checked here rather than at the server because the answer
      is already on this page: a token is built from the cohort code and the
      address, by a rule two Mechanic tasks share and resolveStudentToken
      repeats. Rebuilding it from what the student typed and comparing is the
      same question the server would be asked, without the wait.

      It is a check against mistakes, not against strangers. Whoever holds this
      link already holds the token, so this cannot be a security boundary and
      is not written as one — it catches a link opened by the wrong person in a
      shared inbox, or a student who has two addresses and picked the wrong one.

      Hence the way out. One token in this system was not derived from anything
      (it had to dodge a handle collision), and a student of that kind would be
      told, wrongly and permanently, that their own link is not theirs. Refusing
      a real student their payment is the worse failure of the two.
    */
    function startStepZero() {
      var loading = document.getElementById('loading-state');
      if (loading) loading.style.display = 'none';

      showStudentStateScreen('link-verify-screen');

      var field = document.getElementById('link-verify-email');
      var button = document.getElementById('link-verify-go');

      if (field) {
        field.focus();
        /* A different address is a new question: the link is checked again. */
        field.addEventListener('input', function() { stepZeroSkipLinkCheck = false; });
        field.addEventListener('keydown', function(event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            submitStepZero();
          }
        });
      }

      if (button) button.addEventListener('click', submitStepZero);
    }

    function setStepZeroWorking(working) {
      var button = document.getElementById('link-verify-go');
      if (!button) return;

      button.disabled = !!working;
      button.textContent = working ? 'Checking…' : 'Continue';
    }

    /* The roster refusal on step 0, redrawn when Ask to be added changes state. */
    function showStepZeroRosterRefusal() {
      var box = document.getElementById('link-verify-error');
      if (!box) return;

      box.innerHTML = getEmailRosterHintHtml();
      box.setAttribute('data-roster-refusal', '1');
      box.hidden = false;
      box.setAttribute('aria-hidden', 'false');
    }

    function linkVerificationError(html) {
      var box = document.getElementById('link-verify-error');
      if (!box) return;

      box.innerHTML = html;
      box.removeAttribute('data-roster-refusal');
      box.hidden = false;
      box.setAttribute('aria-hidden', 'false');

      /*
        2026-10-09 (owner) - the way out skips the link check and nothing else.
        It used to jump straight to the "only delivery is left to pay" screen,
        so a student with a typo who had not filled in the form landed on a
        payment screen with nothing to pay. Now the address goes on the usual
        way: no form yet - to the form, where step 1 checks it against the
        school's list; form already in - to their payment.
      */
      var anyway = box.querySelector('.link-verify-anyway');
      if (anyway) anyway.addEventListener('click', function() {
        stepZeroSkipLinkCheck = true;
        submitStepZero();
      });
    }

    var stepZeroSkipLinkCheck = false;

    /*
      ── Step 0 ────────────────────────────────────────────────────────────

      One address, and three things decided by it.

      First, when the visitor arrived on a personal link, whether the address
      belongs to that link. The token is built from the cohort code and the
      address by a rule two Mechanic tasks share, so rebuilding it here asks
      the same question the server would, without the wait. It catches a link
      opened by the wrong person in a shared inbox — a mistake, not an attack,
      since whoever holds the link already holds the token. Hence the way out
      on the error: one token in this system was never derived from anything,
      and refusing a real student their payment is the worse failure.

      Then, whether they have already answered the form. That is the lock list
      this page has always polled.

      Then, if they have, their payment link - found from nothing but the
      address. Which is the whole point: at the school this was built for, our
      letters are refused, so the link in a letter cannot be the only way back.
    */
    function submitStepZero() {
      var field = document.getElementById('link-verify-email');
      var typed = normalizeEmail(field ? field.value : '');

      if (!isValidEmail(typed)) {
        linkVerificationError('Please enter a full email address, the one you gave your school.');
        return;
      }

      var cohortCode = String((ACTIVE_COHORT && ACTIVE_COHORT.cohortCode) || '').trim();
      var derived = handleizeLike(handleizeLike(cohortCode) + '-' + typed);
      var urlToken = String(URL_TOKEN || '').trim();

      if (isClassmateOnForeignLink(typed)) {
        linkVerificationError('<b>' + FOREIGN_LINK_TITLE + '</b> ' + FOREIGN_LINK_TEXT);
        return;
      }

      if (urlToken && derived !== urlToken && !stepZeroSkipLinkCheck) {
        linkVerificationError(
          'That address does not match this link. Check for a typo, or open the link from your own email — ' +
          'each student has one of their own. ' +
          '<button type="button" class="link-verify-anyway">This is my link and my address</button>'
        );
        return;
      }

      var errorBox = document.getElementById('link-verify-error');
      if (errorBox) errorBox.hidden = true;

      setStepZeroWorking(true);

      fetchSubmissionState()
        .catch(function() { return { locks: [], items: [] }; })
        .then(function(state) {
          setStepZeroWorking(false);

          var alreadySubmitted = isSubmissionLockedInList(state.locks, cohortCode, typed);

          if (!alreadySubmitted) {
            /*
              2026-10-09 (owner) - an address that is not on the school's list
              is refused right here, before the student types their name, ID
              and phone only to be stopped at the end of step 1. Same list and
              same rule as step 1 (getLocalRosterMatch): only a definite "not on
              the list" stops them, and Ask to be added works from here.
            */
            if (getLocalRosterMatch(typed) === false) {
              var rosterForm = document.getElementById('student-form');
              if (rosterForm && rosterForm.email) rosterForm.email.value = typed;
              showStepZeroRosterRefusal();
              return;
            }

            /*
              Nothing on file: they are here to fill the form in, so the gate
              that guards it applies to them and not to the student above.
            */
            if (!canOpenStudentForm(ACTIVE_COHORT, urlToken)) {
              var blockReason = getLateResubmitBlockReason(ACTIVE_COHORT, urlToken);
              showInvalid(
                blockReason ? blockReason.title : 'Form closed',
                blockReason ? blockReason.message : 'This form is closed.'
              );
              return;
            }

            openWizardFromStepZero(typed);
            return;
          }

          /*
            The link they arrived on may have carried nothing. Both halves are
            recoverable from the address: the token by the shared rule, the
            items from what the submit task stored while they still owe.
          */
          if (!urlToken) URL_TOKEN = derived;

          passLinkVerification();
        });
    }

    /*
      Opens the wizard, with everything init used to do the moment a cohort was
      found. It waits for step 0 now, because until an address is given there
      is no way to know whether this student needs a form at all.
    */
    function openWizardFromStepZero(typedEmail) {
      var screen = document.getElementById('link-verify-screen');
      if (screen) screen.style.display = 'none';

      applyDemoDeliveryOverride(initParams);

      var loading = document.getElementById('loading-state');
      if (loading) loading.style.display = 'none';

      var container = document.getElementById('form-container');
      if (container) container.style.display = 'block';

      var hero = document.querySelector('.student-hero');
      if (hero) hero.style.display = '';

      /*
        2026-08-20 — and the wizard itself, which is the point of this screen.

        showStudentStateScreen hides three things to put step 0 up: the wizard,
        the hero and the loading card. This function put two of them back and
        forgot the form, so a student who had not answered yet arrived at a
        heading, an instruction to choose their sizes, and nothing to choose
        them with.

        Restored to the stylesheet's own value rather than to "block": the
        wizard's display belongs to the CSS, and pinning it here would be a
        second opinion waiting to disagree.
      */
      var wizard = document.getElementById('student-wizard');
      if (wizard) wizard.style.display = '';

      renderDeadline();
      configureDeliveryMode();
      /* Before the items: it decides which of them there are. */
      renderCampusChoice();
      renderProgramChoice();
      renderProducts();
      bindWizard();
      continueCheckInFlight = false;
      submissionLocked = false;
      setEmailCheckLoading(false);

      var form = document.getElementById('student-form');
      if (form && form.email && typedEmail) form.email.value = typedEmail;

      goToStep(1);
    }

    function passLinkVerification() {
      var field = document.getElementById('link-verify-email');
      var typed = normalizeEmail(field ? field.value : '');

      /* Заполняется поле формы: экран оплаты и корзина берут адрес оттуда,
         как и при обычном пути через шаг 1. */
      var form = document.getElementById('student-form');
      if (form && form.email && typed) form.email.value = typed;

      var screen = document.getElementById('link-verify-screen');
      if (screen) screen.style.display = 'none';

      renderAlreadySubmittedNotice('Your uniform is waiting — only delivery is left to pay for.');
    }

    function showStudentStateScreen(screenId) {
      if (screenId === 'submission-pending-screen') {
        renderReturningStudentPayPanel('pending-cart');
      }

      var wizard = document.getElementById('student-wizard');
      var hero = document.querySelector('.student-hero');
      var loading = document.getElementById('loading-state');
      var screen = document.getElementById(screenId);

      if (wizard) wizard.style.display = 'none';
      if (hero) hero.style.display = 'none';
      if (loading) loading.style.display = 'none';
      if (screen) screen.style.display = 'block';

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function syncStepOneContinueButton() {
      if (currentStep !== 1) return;

      var nextButton = document.getElementById('next-btn');
      if (!nextButton) return;

      nextButton.disabled = !!submissionLocked || !!continueCheckInFlight || !!emailTaken;
      nextButton.classList.toggle('is-loading', continueCheckInFlight);
      nextButton.textContent = 'Continue';
    }

    /*
      Inline, next to the field, not a full screen: unlike "already submitted"
      this is something the student can fix by typing their own address, and a
      dead-end screen would leave them with nowhere to go.
    */
    function renderEmailTakenNotice(highlight, text) {
      emailTaken = true;

      var box = document.getElementById('email-error-notice');
      if (box) {
        box.innerHTML =
          '<div class="notice-icon">!</div>' +
          '<div class="notice-content">' +
            '<span class="notice-highlight">' + esc(highlight || 'This email belongs to another student.') + '</span> ' +
            '<span class="notice-text">' + esc(text || 'Please enter your own email address, or contact your school admin if you think this is a mistake.') + '</span>' +
          '</div>';
        box.style.display = 'flex';
      }

      syncStepOneContinueButton();
    }

    function hideEmailTakenNotice() {
      if (!emailTaken) return;
      emailTaken = false;
      hideEmailErrorNotice();
      syncStepOneContinueButton();
    }

    /*
      2026-08-11 — the same question the typing path already asks, asked on the
      button too.

      A lock is keyed on the ADDRESS. refreshEmailNoticesForCurrentEmail was
      taught to check who owns it before choosing its words, but Continue was
      not: it read the lock and went straight to the dead-end screen, so a
      student who typed a classmate's address was told they had already filled
      in the form and sent to their admin over a typo they could fix themselves.

      The answer only decides the wording — either way this address does not
      pass. Anything unclear (no webhook, an error, a slow reply) keeps the
      screen we show today, which is the safer of the two to be wrong about.
    */
    var LOCKED_WORDING_MAX_WAIT_MS = 4500;

    function refuseLockedContinue(cohortCode, email) {
      if (!SUBMISSION_LOCKS_CACHE_URL || !STUDENT_SUBMIT_WEBHOOK_URL) {
        return Promise.reject(new Error('already confirmed'));
      }

      var askWhoOwnsIt = triggerSubmissionStatusCheck(buildStatusCheckPayload()).then(function() {
        return pollSubmissionFlags(cohortCode, email);
      }).then(function(flags) {
        return !!(flags && flags.taken);
      }).catch(function() {
        return false;
      });

      /*
        The dead-end screen already waits out five seconds from the click, so
        this round trip costs the student no visible time — it fits inside a
        wait that is happening anyway.
      */
      return Promise.race([
        askWhoOwnsIt,
        waitMs(LOCKED_WORDING_MAX_WAIT_MS).then(function() {
          return false;
        })
      ]).then(function(belongsToAnotherStudent) {
        if (belongsToAnotherStudent) {
          renderEmailTakenNotice();
          throw new Error(EMAIL_TAKEN_ERROR);
        }

        throw new Error('already confirmed');
      });
    }

    function runStepOneContinueChecks(cohortCode, email) {
      return isEmailSubmissionLocked(cohortCode, email).then(function(alreadyLocked) {
        if (alreadyLocked) {
          return refuseLockedContinue(cohortCode, email);
        }

        if (SUBMISSION_LOCKS_CACHE_URL && STUDENT_SUBMIT_WEBHOOK_URL) {
          if (!applyRosterHintForEmail(email)) {
            resolveEmailRosterUnmatched(cohortCode, email).then(function(unmatched) {
              if (unmatched) {
                setEmailRosterUnmatched(true);
              }
            });
          }

          var lockCheck = triggerSubmissionStatusCheck(buildStatusCheckPayload()).then(function() {
            return pollSubmissionFlags(cohortCode, email);
          }).then(function(flags) {
            /*
              Continue is refused outright when the address is somebody else's.
              The task refuses it too, but that refusal never reaches this page,
              so without this the student would be told nothing and their answers
              would silently go nowhere.
            */
            if (flags.taken) {
              renderEmailTakenNotice();
              throw new Error(EMAIL_TAKEN_ERROR);
            }

            hideEmailTakenNotice();

            return pollSubmissionLockOnly(cohortCode, email);
          }).then(function(locked) {
            if (locked) {
              throw new Error('already confirmed');
            }
          });

          return Promise.race([
            lockCheck,
            waitMs(2200).then(function() {
              return null;
            })
          ]);
        }

        return null;
      });
    }

    function isAlreadySubmittedError(message) {
      return /already confirmed|already submitted/i.test(String(message || ''));
    }

    function buildSubmissionLockEntry(cohortCode, email) {
      return normalizeCode(cohortCode) + '|' + normalizeEmail(email);
    }

    function isSubmissionCachedLocally(cohortCode, email) {
      try {
        return localStorage.getItem('cohort_submission_lock:' + buildSubmissionLockEntry(cohortCode, email)) === '1';
      } catch (error) {
        return false;
      }
    }

    function markSubmissionCachedLocally(cohortCode, email) {
      try {
        localStorage.setItem('cohort_submission_lock:' + buildSubmissionLockEntry(cohortCode, email), '1');
      } catch (error) {
        return;
      }
    }

    function clearSubmissionCachedLocally(cohortCode, email) {
      try {
        localStorage.removeItem('cohort_submission_lock:' + buildSubmissionLockEntry(cohortCode, email));
      } catch (error) {
        return;
      }
    }

    function parseSubmissionState(data) {
      var raw = data;

      if (typeof raw === 'string') {
        try {
          raw = JSON.parse(raw);
        } catch (error) {
          return { locks: [], unmatched: [] };
        }
      }

      if (raw && typeof raw.value !== 'undefined') {
        raw = raw.value;

        if (typeof raw === 'string') {
          try {
            raw = JSON.parse(raw);
          } catch (error) {
            return { locks: [], unmatched: [] };
          }
        }
      }

      if (Array.isArray(raw)) {
        return {
          locks: raw,
          unmatched: []
        };
      }

      if (raw && typeof raw === 'object') {
        /*
          2026-08-20 — paid, unpaid and items were being dropped here.

          readPaymentStateFromState has read state.paid and state.unpaid since
          15 August and this function never carried them, so it answered "" —
          "we do not know" — every single time. The returning student's panel
          was written to hedge politely on that answer, which is why nothing
          ever looked broken: a debtor and somebody who had already paid were
          shown the same careful wording, forever.

          Silent for five days, and only found because items had to be read
          from the same place.
        */
        return {
          locks: Array.isArray(raw.locks) ? raw.locks : [],
          unmatched: Array.isArray(raw.unmatched) ? raw.unmatched : [],
          taken: Array.isArray(raw.taken) ? raw.taken : [],
          paid: Array.isArray(raw.paid) ? raw.paid : [],
          unpaid: Array.isArray(raw.unpaid) ? raw.unpaid : [],
          items: Array.isArray(raw.items) ? raw.items : []
        };
      }

      return {
        locks: [],
        unmatched: [],
        taken: [],
        paid: [],
        unpaid: [],
        items: []
      };
    }

    function fetchSubmissionState() {
      if (!SUBMISSION_LOCKS_CACHE_URL) {
        return Promise.resolve({ locks: [], unmatched: [] });
      }

      return fetch(SUBMISSION_LOCKS_CACHE_URL, {
        method: 'GET',
        cache: 'no-store'
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        return parseSubmissionState(data);
      }).catch(function() {
        return { locks: [], unmatched: [] };
      });
    }

    function isSubmissionUnmatchedInState(state, cohortCode, email) {
      var entry = buildSubmissionLockEntry(cohortCode, email);
      return (state.unmatched || []).indexOf(entry) !== -1;
    }

    function isSubmissionTakenInState(state, cohortCode, email) {
      var entry = buildSubmissionLockEntry(cohortCode, email);
      return (state.taken || []).indexOf(entry) !== -1;
    }

    /*
      2026-08-15 — three answers, not two: paid, not paid, and no answer yet.

      The server keeps the first two in separate lists precisely so the third
      can be told apart. Absence from both means the status check has not
      landed, and the panel keeps its careful wording rather than telling a
      student they are finished on no evidence.
    */
    function readPaymentStateFromState(state, cohortCode, email) {
      var entry = buildSubmissionLockEntry(cohortCode, email);

      if ((state.unpaid || []).indexOf(entry) !== -1) return 'unpaid';
      if ((state.paid || []).indexOf(entry) !== -1) return 'paid';

      return '';
    }

    function isSubmissionLockedInList(locksList, cohortCode, email) {
      var entry = buildSubmissionLockEntry(cohortCode, email);
      return (locksList || []).indexOf(entry) !== -1;
    }

    function waitMs(ms) {
      return new Promise(function(resolve) {
        setTimeout(resolve, ms);
      });
    }

    function pollSubmissionLockOnly(cohortCode, email) {
      var attempts = 0;
      var maxAttempts = 10;

      function attempt() {
        return fetchSubmissionState().then(function(state) {
          if (isSubmissionLockedInList(state.locks, cohortCode, email)) {
            return true;
          }

          attempts += 1;

          if (attempts >= maxAttempts) {
            return false;
          }

          return waitMs(150).then(attempt);
        });
      }

      return waitMs(80).then(attempt);
    }

    /*
      One loop for both answers (2026-08-10). The status check writes "not on
      the approved list" and "belongs to someone else" in the same cache write,
      so polling for them separately would double the wait for no reason.
    */
    function pollSubmissionFlags(cohortCode, email, options) {
      var attempts = 0;
      var maxAttempts = (options && options.maxAttempts) || 8;
      var intervalMs = (options && options.intervalMs) || 220;
      var initialDelayMs = (options && options.initialDelayMs) || 120;

      function attempt() {
        return fetchSubmissionState().then(function(state) {
          var flags = {
            unmatched: isSubmissionUnmatchedInState(state, cohortCode, email),
            taken: isSubmissionTakenInState(state, cohortCode, email),
            /* '' until the status check lands — see readPaymentStateFromState. */
            payment: readPaymentStateFromState(state, cohortCode, email)
          };

          if (flags.unmatched || flags.taken || flags.payment) {
            return flags;
          }

          attempts += 1;

          if (attempts >= maxAttempts) {
            return flags;
          }

          return waitMs(intervalMs).then(attempt);
        });
      }

      return waitMs(initialDelayMs).then(attempt);
    }

    function pollSubmissionRosterHint(cohortCode, email, options) {
      return pollSubmissionFlags(cohortCode, email, options).then(function(flags) {
        return flags.unmatched;
      });
    }

    function isEmailSubmissionLocked(cohortCode, email) {
      var lockedLocally = isSubmissionCachedLocally(cohortCode, email);

      if (!SUBMISSION_LOCKS_CACHE_URL) {
        return Promise.resolve(lockedLocally);
      }

      // The local flag is only a same-browser fast-path; it never gets
      // cleared when an admin removes the student or fixes their email, so
      // it can go stale and falsely block a genuinely-pending resubmission.
      // Reconcile it against the server-side lock list (shared across
      // devices, and kept in sync by the admin actions) instead of trusting
      // it forever.
      return fetchSubmissionState().then(function(state) {
        var lockedOnServer = isSubmissionLockedInList(state.locks, cohortCode, email);

        if (!lockedOnServer && lockedLocally) {
          clearSubmissionCachedLocally(cohortCode, email);
        }

        return lockedOnServer;
      }).catch(function() {
        return lockedLocally;
      });
    }

    function isCurrentEmailNoticeRequest(requestId, email) {
      if (requestId !== emailNoticeRequestId) return false;

      var form = document.getElementById('student-form');
      if (!form) return false;

      return normalizeEmail(form.email.value || '') === email;
    }

    function refreshEmailNoticesForCurrentEmail() {
      var form = document.getElementById('student-form');
      if (!form || !ACTIVE_COHORT) return Promise.resolve();

      var email = normalizeEmail(form.email.value || '');
      if (!isValidEmail(email)) {
        hideAlreadySubmittedNotice();
        hideEmailRosterHintNotice();
        return Promise.resolve();
      }

      if (isClassmateOnForeignLink(email)) {
        ++emailNoticeRequestId;
        hideAlreadySubmittedNotice();
        hideEmailRosterHintNotice();
        renderEmailTakenNotice(FOREIGN_LINK_TITLE, FOREIGN_LINK_TEXT);
        return Promise.resolve();
      }

      var requestId = ++emailNoticeRequestId;
      var cohortCode = ACTIVE_COHORT.cohortCode;

      return isEmailSubmissionLocked(cohortCode, email).then(function(locked) {
        if (!isCurrentEmailNoticeRequest(requestId, email)) return;

        if (locked) {
          /*
            2026-08-11 — a lock is keyed on the ADDRESS, and the address may not
            be this student's. Typing a classmate's, when the classmate has
            already submitted, said "you have already confirmed this form" —
            true of the address, wrong about the person, and it sent the student
            to their admin over what is really a typo they can fix themselves.

            So ask the server before choosing the words. The extra round trip
            happens only in this case, and the answer decides between a message
            that ends the conversation and one the student can act on.
          */
          if (!SUBMISSION_LOCKS_CACHE_URL || !STUDENT_SUBMIT_WEBHOOK_URL) {
            renderAlreadySubmittedNotice('Contact your school admin if you need changes.');
            return;
          }

          return triggerSubmissionStatusCheck({
            action: 'check_submission_status',
            source: 'cohort_student_form',
            cohort_code: normalizeCode(cohortCode),
            cohort_id: normalizeCode(ACTIVE_COHORT.cohortId || cohortCode),
            email: email,
            token: URL_TOKEN
          }).then(function() {
            return pollSubmissionFlags(cohortCode, email);
          }).then(function(flags) {
            if (!isCurrentEmailNoticeRequest(requestId, email)) return;

            if (flags.taken) {
              renderEmailTakenNotice();
              return;
            }

            renderAlreadySubmittedNotice('Contact your school admin if you need changes.');
          }).catch(function() {
            renderAlreadySubmittedNotice('Contact your school admin if you need changes.');
          });
        }

        hideAlreadySubmittedNotice();

        if (applyRosterHintForEmail(email)) {
          return;
        }

        if (!SUBMISSION_LOCKS_CACHE_URL || !STUDENT_SUBMIT_WEBHOOK_URL) {
          hideEmailRosterHintNotice();
          return;
        }

        return triggerSubmissionStatusCheck({
          action: 'check_submission_status',
          source: 'cohort_student_form',
          cohort_code: normalizeCode(cohortCode),
          cohort_id: normalizeCode(ACTIVE_COHORT.cohortId || cohortCode),
          email: email,
          /* Same reason as buildStatusCheckPayload — see the note there. */
          token: URL_TOKEN
        }).then(function() {
          if (!isCurrentEmailNoticeRequest(requestId, email)) return;

          return pollSubmissionFlags(cohortCode, email).then(function(flags) {
            if (!isCurrentEmailNoticeRequest(requestId, email)) return;

            /* Refusal wins over the hint: one is a warning, the other a stop. */
            if (flags.taken) {
              hideAlreadySubmittedNotice();
              hideEmailRosterHintNotice();
              renderEmailTakenNotice();
              return;
            }

            hideEmailTakenNotice();

            var unmatched = flags.unmatched;

            if (unmatched) {
              hideAlreadySubmittedNotice();
              renderEmailRosterHintNotice();
            } else {
              hideEmailRosterHintNotice();
            }
          });
        });
      });
    }

    function triggerSubmissionStatusCheck(payload) {
      if (!STUDENT_SUBMIT_WEBHOOK_URL) {
        return Promise.resolve();
      }

      return fetch(STUDENT_SUBMIT_WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }).catch(function() {
        return null;
      });
    }

    function buildStatusCheckPayload() {
      var form = document.getElementById('student-form');

      return {
        action: 'check_submission_status',
        source: 'cohort_student_form',
        cohort_code: normalizeCode(ACTIVE_COHORT.cohortCode),
        cohort_id: normalizeCode(ACTIVE_COHORT.cohortId || ACTIVE_COHORT.cohortCode),
        email: normalizeEmail(form.email.value || ''),
        /*
          2026-08-11 — the check has to ask about the submission that is
          actually going to happen. Without the token the task resolves the
          student by address instead, lands on whoever owns the typed address,
          and reports no collision — so the refusal only surfaced afterwards,
          in the task log, while the student was shown success.
        */
        token: URL_TOKEN
      };
    }

    function attemptAdvanceFromCurrentStep() {
      var form = document.getElementById('student-form');
      var message = document.getElementById('student-status');

      message.textContent = '';

      if (!validateStep(currentStep)) {
        return;
      }

      if (currentStep !== 1) {
        goToStep(getNextStep(currentStep));
        return;
      }

      if (submissionLocked) {
        message.textContent = 'You have already confirmed this form. Change your email to continue.';
        return;
      }

      if (continueCheckInFlight) {
        return;
      }

      if (!ACTIVE_COHORT) {
        message.textContent = 'This form is not ready yet. Refresh the page and try again.';
        return;
      }

      var cohortCode = ACTIVE_COHORT.cohortCode;
      var email = normalizeEmail(form.email.value || '');

      if (isClassmateOnForeignLink(email)) {
        renderEmailTakenNotice(FOREIGN_LINK_TITLE, FOREIGN_LINK_TEXT);
        return;
      }

      continueCheckInFlight = true;
      setEmailCheckLoading(true);
      applyRosterHintForEmail(email);

      /*
        2026-08-06 — the "already filled in" screen waits out five seconds from
        the moment Continue was pressed.

        The local lock answers instantly, so the screen used to replace the form
        in the same frame as the click. That reads as the form rejecting what
        was just typed — a validation error — rather than as the result of
        looking the address up. The delay is not a fake progress bar: the
        "checking your email" line is already on screen and the wait makes it
        true to look at. Nothing else is slowed; a student who may continue
        still does so the moment the check clears.
      */
      var ALREADY_SUBMITTED_MIN_WAIT_MS = 5000;
      var checkStartedAt = Date.now();

      runStepOneContinueChecks(cohortCode, email).then(function() {
        goToStep(getNextStep(currentStep));
      }).catch(function(error) {
        var errorMessage = error && error.message ? error.message : 'Unable to continue. Please try again.';

        if (isAlreadySubmittedError(errorMessage) || errorMessage === 'already confirmed') {
          /*
            Move on to step two first, then replace it. Pressing Continue and
            staying put is how a form says "what you typed is wrong", and that
            is not what happened here — the address was accepted, it simply
            turns out to have been used already. Advancing keeps the answer
            about the submission rather than about the field.
          */
          goToStep(getNextStep(currentStep));

          var elapsed = Date.now() - checkStartedAt;
          var remaining = Math.max(0, ALREADY_SUBMITTED_MIN_WAIT_MS - elapsed);

          /* Returned, not fired and forgotten: finally() has to keep the
             loading state up until the screen is actually shown. */
          return waitMs(remaining).then(function() {
            renderAlreadySubmittedNotice('Contact your school admin if you need changes.');
          });
        }

        /* The notice by the field already explains it, and it stays until the
           student edits the address. Stay on step one — this one IS about what
           they typed. */
        if (errorMessage === EMAIL_TAKEN_ERROR) {
          message.textContent = '';
          return;
        }

        message.textContent = errorMessage;
      }).finally(function() {
        continueCheckInFlight = false;
        setEmailCheckLoading(false);
        syncStepOneContinueButton();
      });
    }

    function updateEmailValidationUI() {
      var form = document.getElementById('student-form');
      if (!form) return true;

      var email = normalizeEmail(form.email.value || '');

      if (!email) {
        hideEmailErrorNotice();
        return false;
      }

      if (!isValidEmail(email)) {
        hideEmailRosterHintNotice();
        renderEmailErrorNotice('Please enter a valid email address.');
        return false;
      }

      hideEmailErrorNotice();
      return true;
    }

    /*
      Does this cohort ship to students' homes? Read by the review, the
      success screen and the submission (ship_to_students). Since 2026-10-06
      the form asks no address: UPS delivers to the address typed at
      checkout. The address step (fields, banner, skip card, error notice)
      was removed from the code on 2026-10-08 (owner).
    */
    function configureDeliveryMode() {
      var intro = document.getElementById('student-intro');

      SHIPPING_REQUIRED = !!(ACTIVE_COHORT && (
        ACTIVE_COHORT.deliveryMode === 'home_delivery' ||
        ACTIVE_COHORT.shipToStudents === true ||
        ACTIVE_COHORT.shipToStudents === 'true' ||
        ACTIVE_COHORT.orderType === 'individual_student_orders' ||
        ACTIVE_COHORT.orderType === 'individual_student_order'
      ));

      AVAILABLE_STEPS = [1, 3, 4];
      if (intro) intro.textContent = 'Please enter your information and carefully select your sizes.';
      renderPhoneHint();
    }

    /*
      2026-10-06 - why the phone is asked here and again later (owner). The
      number on this form is for the school. A student who pays for delivery
      types a phone again at checkout; that one travels with the parcel, so the
      delivery company can call if something goes wrong with the order.
    */
    var PHONE_HINT_SCHOOL = 'This number is for your school.';
    var PHONE_HINT_TWICE = 'You will be asked for a phone number again on the payment page — that one goes to the delivery company, in case there is a problem with your order.';

    function renderPhoneHint() {
      var hint = document.getElementById('student-phone-hint');
      if (!hint) return;
      hint.innerHTML = '<strong>' + esc(PHONE_HINT_SCHOOL) + '</strong>' +
        (studentPaysForDelivery() ? ' ' + esc(PHONE_HINT_TWICE) : '');
    }

    function applyDemoDeliveryOverride(params) {
      if (!ACTIVE_COHORT || !params) return;

      var demoDelivery = String(params.get('delivery') || params.get('demo_delivery') || '').trim().toLowerCase();

      if (demoDelivery !== 'home' && demoDelivery !== 'home_delivery') {
        return;
      }

      ACTIVE_COHORT.deliveryMode = 'home_delivery';
      ACTIVE_COHORT.orderType = 'individual_student_orders';
      ACTIVE_COHORT.shipToStudents = true;
    }

    function getProductQuantity(product) {
      var raw =
        product.quantity != null ? product.quantity :
        product.quantity_per_student != null ? product.quantity_per_student :
        product.qty != null ? product.qty :
        product.selected_quantity != null ? product.selected_quantity :
        1;

      var quantity = parseInt(raw, 10);

      if (isNaN(quantity) || quantity < 1) {
        return 1;
      }

      return quantity;
    }

    function getProductId(product) {
      return String(product.product_id || product.id || '').trim();
    }

    function getProductGid(product) {
      var productId = getProductId(product);
      return String(product.product_gid || product.gid || (productId ? 'gid://shopify/Product/' + productId : '')).trim();
    }

    function getVariantGid(variant) {
      return String(variant.gid || variant.id || variant.variant_gid || '').trim();
    }

    function getVariantId(variant) {
      return String(variant.variant_id || variant.id || variant.gid || '').split('/').pop();
    }

    /*
      ── Campus on the student form (2026-08-11, phase 4) ──────────────────────

      Derived from the items, not stored separately. Every item the admin chose
      on Step 3 carries the campus it was chosen under, so the cohort's campus
      list is simply the distinct campuses across its items — and the student's
      campus is the one whose items they submitted.

      That is why no field was added to student_entry: the answer already
      travels with the sizes, and a second copy could only disagree with them.
      Older cohorts have no campus on their items and behave exactly as before.
    */
    function getCohortCampuses() {
      var raw = (ACTIVE_COHORT && ACTIVE_COHORT.products) || [];
      var seen = {};
      var list = [];

      raw.forEach(function(item) {
        var handle = String(item.campus_handle || '').trim();
        if (!handle || seen[handle]) return;
        seen[handle] = true;
        list.push({ handle: handle, name: String(item.campus_name || handle).trim() });
      });

      return list;
    }

    function itemBelongsToSelectedCampus(item) {
      var handle = String(item.campus_handle || '').trim();
      /* An item with no campus belongs to everyone — that is how every cohort
         created before this phase looks. */
      if (!handle) return true;
      if (!selectedStudentCampus) return false;
      return handle.toLowerCase() === selectedStudentCampus.toLowerCase();
    }

    function renderCampusChoice() {
      var wrap = document.getElementById('student-campus-choice');
      var options = document.getElementById('student-campus-options');
      var note = document.getElementById('student-campus-note');
      var campuses = getCohortCampuses();

      function setNote(text) {
        if (!note) return;
        note.textContent = text || '';
        note.hidden = !text;
        note.setAttribute('aria-hidden', text ? 'false' : 'true');
      }

      if (!campuses.length) {
        if (wrap) { wrap.hidden = true; wrap.setAttribute('aria-hidden', 'true'); }
        selectedStudentCampus = '';
        setNote('');
        return;
      }

      if (campuses.length === 1) {
        /* One campus: chosen for them (owner, 2026-08-10), but said out loud so
           they can tell it is not a mistake that other items are missing. */
        selectedStudentCampus = campuses[0].handle;
        if (wrap) { wrap.hidden = true; wrap.setAttribute('aria-hidden', 'true'); }
        setNote('These items are for ' + campuses[0].name + '.');
        return;
      }

      if (wrap) { wrap.hidden = false; wrap.setAttribute('aria-hidden', 'false'); }
      setNote(selectedStudentCampus
        ? 'Showing the items for ' + (campuses.filter(function(campus) {
            return campus.handle === selectedStudentCampus;
          })[0] || {}).name + '.'
        : '');

      if (options) {
        options.innerHTML = campuses.map(function(campus) {
          var active = campus.handle === selectedStudentCampus;
          return '<button type="button" class="student-campus-option' + (active ? ' is-active' : '') + '" ' +
            'data-campus="' + esc(campus.handle) + '" aria-pressed="' + (active ? 'true' : 'false') + '">' +
            esc(campus.name) + '</button>';
        }).join('');

        options.querySelectorAll('[data-campus]').forEach(function(button) {
          button.addEventListener('click', function() {
            var next = String(button.getAttribute('data-campus') || '').trim();
            if (next === selectedStudentCampus) return;

            /* Changing campus changes which items exist. Nothing to clear by
               hand: the sizes live in the fields themselves, and renderProducts
               replaces them. */
            selectedStudentCampus = next;
            renderCampusChoice();
            renderProgramChoice();
            renderProducts();
          });
        });
      }
    }

    /*
      ── Program on the student form (2026-10-05, plan stage 4.2) ────────────

      The same idea as the campus, one step further in. Since 2026-08-02 the
      admin assigns each item copy to at most one program on Step 3, and that
      program rides on the item as program_names. Until now it was only a
      caption, so a student of a cohort with two programs was shown the items
      of both and asked to size them all.

      Derived from the items, like the campus: student_entry is at 40 of 40
      fields, and a stored copy could only disagree with the items submitted.

      Rules:
      - only the items of the chosen campus count, so a program offered at
        one campus only is not offered at the other;
      - an item with no program belongs to every program - older cohorts, and
        items the admin left unassigned, look exactly as before;
      - one program or none: no question, nothing is filtered.
    */
    function getItemProgram(item) {
      return String((item && item.program_names) || '').trim();
    }

    function getCohortPrograms() {
      var raw = (ACTIVE_COHORT && ACTIVE_COHORT.products) || [];
      var seen = {};
      var list = [];

      raw.filter(itemBelongsToSelectedCampus).forEach(function(item) {
        var name = getItemProgram(item);
        var key = name.toLowerCase();
        if (!name || seen[key]) return;
        seen[key] = true;
        list.push(name);
      });

      return list;
    }

    function programQuestionOpen() {
      if (getCohortCampuses().length > 1 && !selectedStudentCampus) return false;
      return getCohortPrograms().length > 1;
    }

    function itemBelongsToSelectedProgram(item) {
      var name = getItemProgram(item);
      if (!name) return true;
      if (!programQuestionOpen()) return true;
      if (!selectedStudentProgram) return false;
      return name.toLowerCase() === selectedStudentProgram.toLowerCase();
    }

    function renderProgramChoice() {
      var wrap = document.getElementById('student-program-choice');
      var options = document.getElementById('student-program-options');
      var note = document.getElementById('student-program-note');
      var programs = programQuestionOpen() ? getCohortPrograms() : [];

      function setNote(text) {
        if (!note) return;
        note.textContent = text || '';
        note.hidden = !text;
        note.setAttribute('aria-hidden', text ? 'false' : 'true');
      }

      /* A program picked under another campus may not exist under this one. */
      var stillOffered = programs.some(function(name) {
        return name.toLowerCase() === selectedStudentProgram.toLowerCase();
      });
      if (!stillOffered) selectedStudentProgram = '';

      if (programs.length < 2) {
        if (wrap) { wrap.hidden = true; wrap.setAttribute('aria-hidden', 'true'); }
        setNote('');
        return;
      }

      if (wrap) { wrap.hidden = false; wrap.setAttribute('aria-hidden', 'false'); }
      setNote(selectedStudentProgram ? 'Showing the items for ' + selectedStudentProgram + '.' : '');

      if (options) {
        options.innerHTML = programs.map(function(name) {
          var active = name.toLowerCase() === selectedStudentProgram.toLowerCase();
          return '<button type="button" class="student-campus-option' + (active ? ' is-active' : '') + '" ' +
            'data-program-choice="' + esc(name) + '" aria-pressed="' + (active ? 'true' : 'false') + '">' +
            esc(name) + '</button>';
        }).join('');

        options.querySelectorAll('[data-program-choice]').forEach(function(button) {
          button.addEventListener('click', function() {
            var next = String(button.getAttribute('data-program-choice') || '').trim();
            if (next === selectedStudentProgram) return;
            selectedStudentProgram = next;
            renderProgramChoice();
            renderProducts();
          });
        });
      }
    }

    function renderProducts() {
      var rawAll = ACTIVE_COHORT && ACTIVE_COHORT.products ? ACTIVE_COHORT.products : [];
      var raw = rawAll.filter(itemBelongsToSelectedCampus).filter(itemBelongsToSelectedProgram);
      var container = document.getElementById('product-blocks');
      var entries = [];

      container.innerHTML = '';

      /* No prompt here: the card above already says the items depend on the
         campus, and repeating it twice on one screen read as an error. */
      if (getCohortCampuses().length > 1 && !selectedStudentCampus) {
        return;
      }

      if (programQuestionOpen() && !selectedStudentProgram) {
        return;
      }

      raw.forEach(function(item, rawIndex) {
        var productId = getProductId(item);
        var productGid = getProductGid(item);
        var quantity = getProductQuantity(item);

        for (var itemIndex = 1; itemIndex <= quantity; itemIndex += 1) {
          entries.push({
            pid: productId,
            pgid: productGid,
            title: item.title || item.product_title || 'Product',
            /* Additive (2026-07-31): the program the admin assigned this item to
               in Step 3 (informational only — every student sees every item
               regardless of program, see cohort-admin-form.js). */
            programName: item.program_names || '',
            /* 2026-08-11, phase 4 — travels with the item onto the submission,
               so the order tag and the invoice split can read it later. */
            campusHandle: item.campus_handle || '',
            campusName: item.campus_name || '',
            /*
              2026-08-06 — per-item surcharge, snapshotted onto the cohort at
              creation time from the product's custom.surcharge metafield. Read
              from the snapshot, never live: the amount that applies is the one
              agreed when the cohort was created, so changing the metafield
              later cannot rewrite invoices for cohorts already running.
              Missing on older cohorts, which is why it falls back to 0.
            */
            surcharge: Number(item.surcharge) || 0,
            img: item.image || item.featured_image || '',
            variants: Array.isArray(item.variants) ? item.variants : [],
            idx: itemIndex,
            total: quantity,
            /*
              2026-08-02: rawIndex (position in the cohort.products array) is
              included because Step 3 can now duplicate the same product into
              several separate array entries (one per program copy) — without
              it, two entries sharing the same productId would both compute
              itemIndex=1 and collide on this key, and the second selection
              would silently overwrite the first in the sizes map below.
            */
            key: String(productId || item.title || 'product') + '__' + rawIndex + '__' + itemIndex
          });
        }
      });

      if (!entries.length) {
        container.innerHTML = '<p style="color:var(--danger);grid-column:1/-1;">No products found for this cohort.</p>';
        return;
      }

      entries.forEach(function(entry) {
        var availableVariants = (entry.variants || []).filter(function(variant) {
          if (isHiddenSize(variant)) return false;
          return variant.available !== false && variant.availableForSale !== false;
        });

        var block = document.createElement('div');
        var html = '';

        block.className = 'cohort-product-card';

        html += '<div class="item-card-checkmark"></div>';
        html += '<div class="cohort-product-image">';

        if (entry.img) {
          html += '<img src="' + esc(entry.img) + '" alt="' + esc(entry.title) + '" loading="lazy">';
        } else {
          html += '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:42px;font-weight:900;color:#bbb;">' + esc(String(entry.title).charAt(0)) + '</div>';
        }

        if (entry.total >= 1) {
          html += '<div class="product-badge">Item ' + entry.idx + ' of ' + entry.total + '</div>';
        }

        html += '</div>';
        html += '<p class="cohort-product-title">' + esc(entry.title) + '</p>';

        if (entry.programName) {
          html += '<p class="cohort-product-program">' + esc(entry.programName) + '</p>';
        }

        if (availableVariants.length > 1) {
          html += '<div class="select-wrapper">';
          html += '<select class="cohort-select product-selection" required ' +
            'data-pid="' + esc(entry.pid) + '" ' +
            'data-pgid="' + esc(entry.pgid) + '" ' +
            'data-title="' + esc(entry.title) + '" ' +
            'data-program="' + esc(entry.programName) + '" ' +
            'data-campus-handle="' + esc(entry.campusHandle) + '" ' +
            'data-campus-name="' + esc(entry.campusName) + '" ' +
            'data-surcharge="' + entry.surcharge + '" ' +
            'data-img="' + esc(entry.img) + '" ' +
            'data-key="' + esc(entry.key) + '" ' +
            'data-idx="' + entry.idx + '" ' +
            'data-tot="' + entry.total + '">';

          html += '<option value="">Select size</option>';

          availableVariants.forEach(function(variant, index) {
            /*
              2026-08-05 — never fall back to the SKU. A variant with no real
              option title has no size to show, and printing its SKU put a
              warehouse code in front of the student and then stored it as if it
              were their chosen size, where it surfaced again on the dashboard
              and the status page.
            */
            var label = variant.title && variant.title !== 'Default Title'
              ? variant.title
              : 'Option ' + (index + 1);

            var variantGid = getVariantGid(variant);
            var variantId = getVariantId(variant);

            html += '<option value="' + esc(label) + '" ' +
              'data-vgid="' + esc(variantGid) + '" ' +
              'data-vid="' + esc(variantId) + '" ' +
              'data-vtitle="' + esc(label) + '">' +
              esc(label) +
            '</option>';
          });

          html += '</select>';
          html += '</div>';
        } else if (availableVariants.length === 1) {
          var singleVariant = availableVariants[0];
          /* Same rule as above: a SKU is not a size (2026-08-05). */
          var singleLabel = singleVariant.title && singleVariant.title !== 'Default Title'
            ? singleVariant.title
            : 'One Size';

          var singleVariantGid = getVariantGid(singleVariant);
          var singleVariantId = getVariantId(singleVariant);

          block.classList.add('is-selected');

          html += '<div class="product-included">';
          html += '<strong>Included</strong>';
          html += '<span>No size selection needed</span>';
          html += '</div>';

          html += '<input type="hidden" class="product-selection" value="' + esc(singleLabel) + '" ' +
            'data-pid="' + esc(entry.pid) + '" ' +
            'data-pgid="' + esc(entry.pgid) + '" ' +
            'data-title="' + esc(entry.title) + '" ' +
            'data-program="' + esc(entry.programName) + '" ' +
            'data-campus-handle="' + esc(entry.campusHandle) + '" ' +
            'data-campus-name="' + esc(entry.campusName) + '" ' +
            'data-surcharge="' + entry.surcharge + '" ' +
            'data-img="' + esc(entry.img) + '" ' +
            'data-key="' + esc(entry.key) + '" ' +
            'data-idx="' + entry.idx + '" ' +
            'data-tot="' + entry.total + '" ' +
            'data-vgid="' + esc(singleVariantGid) + '" ' +
            'data-vid="' + esc(singleVariantId) + '" ' +
            'data-vtitle="' + esc(singleLabel) + '">';
        } else {
          /*
            2026-08-06 — was "No available variants." Students do not know what
            a variant is, and the sentence read as a fault in the form rather
            than a fact about the item. The admin picker now refuses to add an
            item in this state, so a student should only reach this line when
            something sold out after the cohort was created.
          */
          html += '<p style="color:var(--danger); text-align:center; font-weight:700;">Out of stock — please tell your school.</p>';
        }

        block.innerHTML = html;
        container.appendChild(block);
      });

      container.addEventListener('change', function(event) {
        if (!event.target.classList.contains('product-selection')) {
          return;
        }

        var card = event.target.closest('.cohort-product-card');

        if (!card) {
          return;
        }

        card.classList.toggle('is-selected', !!event.target.value);
      });
    }

    function collectPayload() {
      var form = document.getElementById('student-form');
      var email = normalizeEmail(form.email.value || '');
      var sizes = {};
      var items = [];

      document.querySelectorAll('.product-selection').forEach(function(selection) {
        var value = selection.value;

        if (!value || String(value).trim() === '') {
          return;
        }

        var option = selection.tagName === 'SELECT' ? selection.options[selection.selectedIndex] : selection;

        var item = {
          instance_key: selection.dataset.key,
          item_number: parseInt(selection.dataset.idx, 10) || 1,
          total_quantity: parseInt(selection.dataset.tot, 10) || 1,
          product_id: selection.dataset.pid || '',
          product_gid: selection.dataset.pgid || '',
          product_title: selection.dataset.title || 'Product',
          /* Additive (2026-07-31): program the admin assigned this item to in
             Step 3, carried through so finalize/create-draft-order can label
             the corresponding draft order line item. Empty when the item isn't
             tied to any program. */
          program_names: selection.dataset.program || '',
          /*
            2026-08-11, phase 4 — the campus this item was chosen under, carried
            the same way and for the same reasons: the tag on the student's
            order and the split of the school invoice both read it from here.
            Empty on cohorts created before campuses moved to Step 3.
          */
          campus_handle: selection.dataset.campusHandle || '',
          campus_name: selection.dataset.campusName || '',
          /*
            2026-08-06 — the surcharge for ONE of this item, frozen at the
            moment the student submits. Finalize multiplies it by the quantity
            rather than looking the product up again, so an invoice can never
            disagree with what the cohort was set up with.
          */
          custom_fee_each: Number(selection.dataset.surcharge) || 0,
          image: selection.dataset.img || '',
          selection: value,
          size: value,
          variant_id: option ? option.dataset.vid || '' : '',
          variant_gid: option ? option.dataset.vgid || '' : '',
          variant_title: option ? option.dataset.vtitle || value : value
        };

        sizes[selection.dataset.key] = item;
        items.push(item);
      });

      return {
        action: 'submit_student_sizes',
        source: 'cohort_student_form',
        cohort_code: normalizeCode(ACTIVE_COHORT.cohortCode),
        cohort_id: normalizeCode(ACTIVE_COHORT.cohortId || ACTIVE_COHORT.cohortCode),
        token: URL_TOKEN,
        school_name: ACTIVE_COHORT.schoolName || '',
        school_code: ACTIVE_COHORT.schoolCode || '',
        delivery_mode: ACTIVE_COHORT.deliveryMode || (ACTIVE_COHORT.orderType === 'school_order' ? 'school_delivery' : 'home_delivery'),
        order_type: ACTIVE_COHORT.orderType,
        ship_to_students: SHIPPING_REQUIRED,
        shipping_required: SHIPPING_REQUIRED,
        first_name: String(form.first_name.value || '').trim(),
        last_name: String(form.last_name.value || '').trim(),
        student_id: String(form.student_id.value || '').trim(),
        email: email,
        student_form_url: ACTIVE_COHORT.studentFormUrl || '',
        status_page_url: ACTIVE_COHORT.statusPageUrl || '',
        deadline: ACTIVE_COHORT.deadline || '',
        deadline_display: ACTIVE_COHORT.deadlineDisplay || ACTIVE_COHORT.deadline || '',
        /*
          2026-10-08 - only the phone, where every reader has found it since
          2026-08-17 (shipping_address.phone). No address on the form since
          2026-10-06. The phone is for the school and for statistics, not
          for the system: every task and screen treats a blank one as "not
          known" and carries on (owner).
        */
        shipping_address: {
          phone: studentPhoneValue(form)
        },
        sizes: sizes,
        items: items,
        submitted_at: new Date().toISOString(),
        return_fee_acknowledgement: 'Student was warned about $16.99 fee'
      };
    }

    /*
      2026-10-13 (owner) - the details as tiles, like the dashboard counters
      (design 2 of docs/other/Cohort-UI/Cohort-Student-Form/review-details-
      variants). Each row holds tiles of the same height: the phone note has
      a row of its own, so the Email tile beside Phone no longer stretches
      into empty space.
    */
    var REVIEW_TRUCK = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M2.6 6.2h10.1v9.1H2.6zM12.7 9.3h3.9l3.4 3.4v2.6h-7.3z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="7" cy="17.6" r="1.9" stroke="currentColor" stroke-width="1.8"/><circle cx="16.6" cy="17.6" r="1.9" stroke="currentColor" stroke-width="1.8"/></svg>';

    function buildReviewDetailsHtml(payload) {
      var name = (String(payload.first_name || '').trim() + ' ' + String(payload.last_name || '').trim()).trim();
      var phone = payload.shipping_address && payload.shipping_address.phone;

      function tile(modifier, label, value) {
        return '<div class="review-tile ' + modifier + '">' +
          '<span class="review-tile-label">' + esc(label) + '</span>' +
          '<span class="review-tile-value">' + esc(value || '—') + '</span>' +
        '</div>';
      }

      /* 2026-10-06 - said once more where the student checks everything,
         for home delivery only: there is no payment page otherwise.
         2026-10-13 (owner) - inside the phone tile, not a row of its own. */
      var phoneNoticeHtml = studentPaysForDelivery()
        ? '<div class="phone-twice-notice">' +
            '<p class="phone-twice-notice-lead">' + esc(PHONE_HINT_SCHOOL) + '</p>' +
            '<p class="phone-twice-notice-text">' + esc(PHONE_HINT_TWICE) + '</p>' +
          '</div>'
        : '';

      var phoneHtml = '<div class="review-tile is-phone">' +
        '<span class="review-tile-label">Phone</span>' +
        '<span class="review-tile-value">' + esc(phone || '—') + '</span>' +
        phoneNoticeHtml +
      '</div>';

      /* 2026-10-13 (owner) - design 1 of review-details-bento-variants, on
         trial: a tall name tile down the left with the initials on top, the
         student ID and email beside it, the phone under them. Design 4 (the
         dark name tile) is the commit before this one. */
      var first = String(payload.first_name || '').trim();
      var last = String(payload.last_name || '').trim();
      var initials = ((first.charAt(0) || '') + (last.charAt(0) || '')).toUpperCase() || '?';
      var studentId = String(payload.student_id || '').trim();

      var nameHtml = '<div class="review-tile is-name">' +
        '<span class="review-name-avatar" aria-hidden="true">' + esc(initials) + '</span>' +
        '<span class="review-name-text">' +
          '<span class="review-tile-label">Name</span>' +
          '<span class="review-tile-value">' + esc(name || '—') + '</span>' +
        '</span>' +
      '</div>';

      var shippingHtml = '<div class="review-tile is-ship">' +
        '<span class="review-ship-icon">' + REVIEW_TRUCK + '</span>' +
        '<span>' +
          '<span class="review-tile-label">Shipping</span>' +
          '<span class="review-tile-value">' +
            (SHIPPING_REQUIRED ? 'To your home — you enter the address on the payment page' : 'School group delivery') +
          '</span>' +
        '</span>' +
      '</div>';

      return (
        '<div class="review-detail-card">' +
          '<h3 class="review-detail-title">Your details</h3>' +
          '<div class="review-tiles">' +
            nameHtml +
            tile('is-id', 'Student ID', studentId) +
            tile('is-email', 'Email', payload.email) +
            phoneHtml +
            shippingHtml +
          '</div>' +
        '</div>'
      );
    }

    function buildReview() {
      var payload = collectPayload();
      var grid = document.getElementById('review-summary-grid');

      if (!payload.items || payload.items.length === 0) {
        grid.innerHTML = buildReviewDetailsHtml(payload) + '<p style="grid-column:1/-1; text-align:center; font-weight:500; color:var(--muted);">No items selected.</p>';
        return;
      }

      grid.innerHTML = buildReviewDetailsHtml(payload) + payload.items.map(function(item) {
        var safeTitle = item.product_title || '?';

        var image = item.image
          ? '<img src="' + esc(item.image) + '" alt="' + esc(safeTitle) + '" loading="lazy">'
          : '<div style="width:100%; aspect-ratio:1/1; display:flex; align-items:center; justify-content:center; font-size:32px; color:#ccc; font-weight:900;">' + esc(safeTitle.charAt(0)) + '</div>';

        return (
          '<div class="review-card">' +
            '<div class="review-card-img">' + image + '</div>' +
            '<p class="review-card-title">' + esc(safeTitle) + '</p>' +
            '<div class="review-card-size">' + esc(item.variant_title || item.selection) + '</div>' +
          '</div>'
        );
      }).join('');
    }

    function validateStep(step) {
      var form = document.getElementById('student-form');
      var message = document.getElementById('student-status');

      message.textContent = '';

      if (step === 1) {
        if (!form.first_name.value || !form.last_name.value || !form.student_id.value || !form.email.value) {
          message.textContent = 'Please fill out all required info fields.';
          return false;
        }

        /*
          ── 2026-08-18 — the star was decorative until this line ────────────

          Reported live: the field showed an asterisk and carried `required`,
          and the step could still be walked past. Both are true and neither
          does anything here — the browser enforces `required` on a real form
          submit, and Continue on step one is a plain button. The step is gated
          by this function, so this function is what has to ask.

          Marked required in three places now — the star, the attribute, and
          here — and only the third one stops anybody.
        */
        if (!studentPhoneValue(form)) {
          /*
            2026-10-09 (owner) - say what the number is for: the school, and,
            for a student who pays for delivery, a second number at checkout
            that goes with the parcel in case it gets lost. Same two facts as
            the hint under the field (PHONE_HINT_SCHOOL, PHONE_HINT_TWICE).
          */
          message.textContent = studentPaysForDelivery()
            ? 'Please enter your phone number. It is for your school. You will enter a phone number again at checkout when you pay for delivery, so the delivery company can reach you if your parcel gets lost.'
            : 'Please enter your phone number. It is for your school.';
          return false;
        }

        if (!form.email.checkValidity()) {
          renderEmailErrorNotice('Please enter a valid email address.');
          message.textContent = 'Invalid email.';
          return false;
        }

        if (!updateEmailValidationUI()) {
          message.textContent = 'Please enter a valid email address.';
          return false;
        }

        /*
          2026-10-06 - only students on the school's list (owner, plan 4.3).

          Until today an address the school never sent was let through with a
          hint and marked "not on the approved list" for the admin to sort out
          afterwards. Now it stops here. The list is the cohort's own
          student_emails, already on this page, and it is the same list
          cohort-student-form-submit compares against - so the two cannot
          disagree about who is on it.

          Only a definite "not on the list" stops the student. No list on the
          page (null) is not evidence of anything and lets them through, as
          before: a refusal built on missing data would lock out real students.

          The server still accepts such a submission and marks it unmatched. A
          refusal there would never reach this page (CLAUDE.md, trap 3), so it
          could only lose a student's answers silently.
        */
        if (getLocalRosterMatch(form.email.value) === false) {
          setEmailRosterUnmatched(true);
          message.textContent = '';
          return false;
        }
      }

      if (step === 3) {
        /* 2026-08-11, phase 4 — the campus comes first: until it is answered
           there are no items on screen to size. */
        if (getCohortCampuses().length > 1 && !selectedStudentCampus) {
          message.textContent = 'Please choose your campus first.';
          return false;
        }

        if (programQuestionOpen() && !selectedStudentProgram) {
          message.textContent = 'Please choose your program first.';
          return false;
        }

        var allSelected = true;
        var selectionCount = 0;

        document.querySelectorAll('.product-selection').forEach(function(selection) {
          selectionCount += 1;
          if (!selection.value) {
            allSelected = false;
          }
        });

        if (!selectionCount) {
          message.textContent = 'No selectable products were found for this cohort.';
          return false;
        }

        if (!allSelected) {
          message.textContent = 'Please select a size for every item.';
          return false;
        }
      }

      return true;
    }

    function getNextStep(step) {
      var index = AVAILABLE_STEPS.indexOf(step);
      if (index === -1 || index >= AVAILABLE_STEPS.length - 1) return step;
      return AVAILABLE_STEPS[index + 1];
    }

    function getPreviousStep(step) {
      var index = AVAILABLE_STEPS.indexOf(step);
      if (index <= 0) return AVAILABLE_STEPS[0];
      return AVAILABLE_STEPS[index - 1];
    }

    function goToStep(step) {
      if (AVAILABLE_STEPS.indexOf(step) === -1) {
        step = getNextStep(currentStep);
      }

      currentStep = step;

      document.querySelectorAll('.step-panel').forEach(function(panel) {
        panel.classList.toggle('is-active', parseInt(panel.dataset.stepPanel, 10) === step);
      });

      document.querySelectorAll('.step-tab').forEach(function(tab) {
        var tabStep = parseInt(tab.dataset.stepTab, 10);

        tab.classList.toggle('is-active', tabStep === step);
        tab.classList.toggle('is-complete', AVAILABLE_STEPS.indexOf(tabStep) !== -1 && AVAILABLE_STEPS.indexOf(tabStep) < AVAILABLE_STEPS.indexOf(step));
      });

      document.getElementById('back-btn').style.display = step === AVAILABLE_STEPS[0] ? 'none' : 'inline-flex';

      var right = document.getElementById('nav-right');

      if (step === 4) {
        buildReview();
        right.innerHTML = '<button type="submit" class="nav-btn submit" id="submit-btn">Submit Sizes</button>';
      } else {
        right.innerHTML = '<button type="button" class="nav-btn primary" id="next-btn">Continue</button>';
        syncStepOneContinueButton();
      }

      if (step !== 1) {
        setEmailCheckLoading(false);
      }

      if (step === 4) {
        refreshReviewRosterHint();
      } else {
        syncEmailRosterHintNotices();
      }

      window.scrollTo({
        top: document.getElementById('student-wizard').offsetTop - 20,
        behavior: 'smooth'
      });
    }

    function scrollToSuccessView() {
      var success = document.getElementById('success-screen');
      var shell = document.querySelector('.student-shell');
      if (!success) return;

      var headerOffset = 24;

      function applyScroll() {
        var anchorTop = shell
          ? shell.getBoundingClientRect().top + window.pageYOffset
          : success.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({
          top: Math.max(0, anchorTop - headerOffset),
          left: 0,
          behavior: 'auto'
        });
      }

      applyScroll();
      requestAnimationFrame(applyScroll);
      window.setTimeout(applyScroll, 60);
      window.setTimeout(applyScroll, 180);
    }

    /*
      What happens next depends entirely on how this cohort ships, and the
      student has no way to work that out for themselves. Home delivery means
      another email and a payment for shipping; school delivery means the box
      arrives at school and there is nothing further for them to do. Saying only
      the relevant one removes a condition the reader cannot resolve.
    */
    function renderSuccessCopy() {
      var container = document.getElementById('success-copy');
      if (!container) return;

      var mode = String((ACTIVE_COHORT && ACTIVE_COHORT.deliveryMode) || '').trim().toLowerCase();
      var isHome = mode === 'home_delivery' || SHIPPING_REQUIRED;
      var mailLink = '<a href="mailto:contact@apres-scrubs.com">contact@apres-scrubs.com</a>';
      var lines;

      if (isHome) {
        /*
          Cut to one line, 2026-08-12 (owner read the finished screen).

          Everything else is said by the payment panel a few centimetres below:
          who pays and that the place is held once the payment goes through.
          The panel keeps those sentences because it is the one with the
          button. What is left here is the only thing the panel does not say.
        */
        lines = [
          'Trouble paying? Contact your school or email us at ' + mailLink + '.'
        ];
      } else {
        lines = [
          'Your school will review your submission shortly. Your uniform is delivered to the school — there is nothing else for you to do.',
          'Questions? Contact your school or email us at ' + mailLink + '.'
        ];
      }

      container.innerHTML = lines.map(function(line) {
        return '<p class="success-dashboard-intro">' + line + '</p>';
      }).join('');
    }

    /*
      The school pays for the uniform; the student pays to have it delivered,
      through their own order (Cohort: Create Student Checkout). Nothing they
      buy for themselves can reach the school's bill: finalize builds that
      from the submitted form, never from an order.
    */

    function cohortShipsHome() {
      var mode = String((ACTIVE_COHORT && ACTIVE_COHORT.deliveryMode) || '').trim().toLowerCase();
      return mode === 'home_delivery';
    }

    /*
      2026-10-16 (owner) - a demo cohort skips the delivery payment: Cohort:
      Student Form Submit confirms its students on submit and no order is
      made, so the page treats them as students who pay nothing and says in
      place of the payment step that it is skipped. Read from the cohort's
      own school code, as the tasks do.
    */
    function isDemoCohort() {
      return String((ACTIVE_COHORT && ACTIVE_COHORT.schoolCode) || '').trim().toUpperCase() === 'DEMO';
    }

    function studentPaysForDelivery() {
      return cohortShipsHome() && !isDemoCohort();
    }

    /*
      Liquid's handleize, ported (2026-08-12).

      Lowercase, every run of anything that is not a letter or digit becomes one
      hyphen, and hyphens at either end are dropped. Emails are ASCII in every
      record this has been checked against, so the accent folding the real
      filter also does has nothing to fold here.
    */
    function handleizeLike(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    }

    /*
      The student's own token — from the URL when they arrived on their personal
      link, worked out from their address when they did not (owner, 2026-08-12).

      The general link off the status page carries no token, and the payment
      hangs off one: the payment link is found by it, and the paid order is
      tied back to the student by it.

      Working it out is not a guess. Two tasks build this token from the same
      two facts and the same rule — cohort-update-roster-emails.liquid:851 when
      a student is added to the roster, cohort-student-form-submit.liquid:871
      when one submits without a token. This repeats that rule.

      When it is wrong the failure is quiet and harmless: a code by that name
      does not exist, so no discount applies — exactly what happens today. The
      one case it cannot reach is a student whose token had to dodge a handle
      collision (cohort-update-roster-emails.liquid:936), whose token is not
      derived from anything. Their payment is still recovered by address in
      cohort-capture-paid-order.liquid.

      The URL always wins where it exists: a token belongs to the entry, never
      to the link somebody arrived on.
    */
    function resolveStudentToken() {
      var fromUrl = String(URL_TOKEN || '').trim();
      if (fromUrl) return fromUrl;

      var cohortCode = String((ACTIVE_COHORT && ACTIVE_COHORT.cohortCode) || '').trim();
      var form = document.getElementById('student-form');
      var email = form && form.email ? normalizeEmail(form.email.value || '') : '';

      if (!cohortCode || !email) return '';

      return handleizeLike(handleizeLike(cohortCode) + '-' + email);
    }

    /*
      2026-10-06 - the free-shipping code for the next order (plan 6.2).
      Made by Cohort: Free Shipping After Payment from the same two facts, so
      it is rebuilt here rather than stored.

      Shown only for cohorts still running when the code was introduced: a
      student of an older cohort paid before any such code existed, and
      showing them one would promise a code that was never made.
    */
    var FREE_SHIPPING_SINCE = '2026-10-06';

    function studentFreeShippingCode() {
      var cohortCode = normalizeCode((ACTIVE_COHORT && ACTIVE_COHORT.cohortCode) || '');
      var token = resolveStudentToken();

      if (!cohortCode || !token) return '';

      var deadline = String((ACTIVE_COHORT && ACTIVE_COHORT.deadline) || '').slice(0, 10);
      if (deadline && deadline < FREE_SHIPPING_SINCE) return '';

      return ('FREESHIP-' + cohortCode + '-' + token).toUpperCase();
    }

    /*
      2026-10-06 (owner) - the note under the Pay for delivery button: a
      free-shipping code for the next order, emailed once the delivery is
      paid and shown again on step 1 of this form.
    */
    function renderExtraSetOffer(node) {
      if (!node) return;

      node.innerHTML =
        '<p class="success-cart-extra-title">Free shipping on your next order</p>' +
        '<p class="success-cart-extra-text">' +
          'After you pay for delivery, we\'ll email you a free-shipping code for your next order — valid for 3 days. You can also see it any time: open your cohort link and enter your email on step 1.</p>';

      node.hidden = false;
      node.setAttribute('aria-hidden', 'false');
    }

    /*
      2026-10-06 - until when the code works (owner).

      Cohort: Free Shipping After Payment keeps each code's end in the cache
      key free_shipping_codes, keyed by the first 24 hex characters of the
      code's SHA-256 - the cache is public, and a code carries an email. The
      form hashes the code it already knows and looks up its own entry.

      Resolves to the end as epoch seconds, or null when there is no answer:
      no cache address set, no entry yet (the task runs a few seconds after
      the payment), or a browser without crypto.subtle. null keeps the plain
      "valid for 3 days after your payment" line - never a wrong date.
    */
    function sha256Hex(text) {
      if (!window.crypto || !window.crypto.subtle || typeof TextEncoder === 'undefined') {
        return Promise.resolve('');
      }

      return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(function(buffer) {
        return Array.prototype.map.call(new Uint8Array(buffer), function(byte) {
          return ('0' + byte.toString(16)).slice(-2);
        }).join('');
      }).catch(function() {
        return '';
      });
    }

    function fetchFreeShippingEnd(code) {
      if (!FREE_SHIPPING_CACHE_URL || !code) return Promise.resolve(null);

      return Promise.all([
        fetch(FREE_SHIPPING_CACHE_URL, { method: 'GET', cache: 'no-store' }).then(function(response) {
          return response.json();
        }),
        sha256Hex(code)
      ]).then(function(results) {
        var raw = results[0];
        var hash = results[1];
        if (!hash) return null;

        if (raw && typeof raw.value !== 'undefined') raw = raw.value;
        if (typeof raw === 'string') raw = JSON.parse(raw);
        if (!raw || typeof raw !== 'object') return null;

        var end = Number(raw[hash.slice(0, 24)]);
        return end > 0 ? end : null;
      }).catch(function() {
        return null;
      });
    }

    /* The code itself, for a student whose delivery is paid. */
    function renderFreeShippingCode(node) {
      if (!node) return;

      var code = studentFreeShippingCode();
      if (!code) {
        hideExtraSetOffer(node);
        return;
      }

      node.innerHTML =
        '<p class="success-cart-extra-title">Free shipping on your next order</p>' +
        '<div class="free-ship-code-row">' +
          '<span class="free-ship-code">' + esc(code) + '</span>' +
          '<button type="button" class="free-ship-copy" data-free-ship-copy>Copy</button>' +
        '</div>' +
        '<p class="success-cart-extra-text"><span data-free-ship-valid>Valid for 3 days after your payment</span>, for one order. Enter it at checkout. ' +
        'If it does not work, write to <a href="mailto:contact@apres-scrubs.com">contact@apres-scrubs.com</a>.</p>';

      node.hidden = false;
      node.setAttribute('aria-hidden', 'false');

      var copyButton = node.querySelector('[data-free-ship-copy]');
      if (copyButton) {
        copyButton.addEventListener('click', function() {
          var done = function() {
            copyButton.textContent = 'Copied';
            copyButton.classList.add('is-done');
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done).catch(function() {});
          }
        });
      }

      (freeShipEndPromise || fetchFreeShippingEnd(code)).then(function(end) {
        var valid = node.querySelector('[data-free-ship-valid]');
        if (!end || !valid) return;

        var date = new Date(end * 1000).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
        valid.textContent = end * 1000 > Date.now()
          ? 'Valid until ' + date
          : 'This code expired on ' + date;
      });
    }

    function hideExtraSetOffer(node) {
      if (!node) return;

      node.innerHTML = '';
      node.hidden = true;
      node.setAttribute('aria-hidden', 'true');
    }

    /*
      ── 2026-10-07 — the student pays through their own order (plan 7.1) ──

      With "Checkout links cache URL" set on the section, a student who pays
      for delivery no longer has their uniform put in the cart. Cohort: Create
      Student Checkout builds them a draft order at the cohort's price, and
      Cohort: Student Checkout Link keeps its payment link in the cache key
      student_checkout_links - keyed by the first 24 hex characters of
      SHA-256("checkout:" + token), because the cache is public and the token
      carries an email. This page waits for that link with a loader, then
      offers one button: Pay for delivery.

      The setting is required since 2026-10-08, when the cart path was
      removed: without it the page waits and then says the link is on its way
      by email.

      The page claims only what it can see: a link in the cache. If none
      arrives within CHECKOUT_LINK_WAIT_MS, it says the link is on its way
      by email (the same task sends it) rather than that anything failed.
    */
    var CHECKOUT_LINKS_CACHE_URL = SECTION_SETTINGS.checkoutLinksCacheUrl || '';
    var CHECKOUT_LINK_WAIT_MS = 90000;
    var CHECKOUT_LINK_POLL_MS = 3000;
    var CHECKOUT_LINK_MIN_MS = 5000;
    var CHECKOUT_LOADER_LINES = [
      'Saving your sizes…',
      'Preparing your order…',
      'Applying your school\'s payment…',
      'Getting your payment link ready…',
      'Almost there — this takes just a moment…'
    ];
    var checkoutLinkTimer = null;
    var checkoutLoaderTimer = null;
    var lastSubmitStartedAt = 0;

    function fetchCheckoutLink(token, notBefore) {
      if (!CHECKOUT_LINKS_CACHE_URL || !token) return Promise.resolve(null);

      return Promise.all([
        fetch(CHECKOUT_LINKS_CACHE_URL, { method: 'GET', cache: 'no-store' }).then(function(response) {
          return response.json();
        }),
        sha256Hex('checkout:' + String(token).toLowerCase())
      ]).then(function(results) {
        var raw = results[0];
        var hash = results[1];
        if (!hash) return null;

        if (raw && typeof raw.value !== 'undefined') raw = raw.value;
        if (typeof raw === 'string') raw = JSON.parse(raw);
        if (!raw || typeof raw !== 'object') return null;

        var entry = raw[hash.slice(0, 24)];
        if (!entry || !entry.u) return null;
        /* A fresh submission waits for the draft made from it, not the one
           it replaced. */
        if (notBefore && Number(entry.t || 0) < notBefore) return null;
        return String(entry.u);
      }).catch(function() {
        return null;
      });
    }

    function stopCheckoutTimers() {
      if (checkoutLinkTimer) clearTimeout(checkoutLinkTimer);
      if (checkoutLoaderTimer) clearInterval(checkoutLoaderTimer);
      checkoutLinkTimer = null;
      checkoutLoaderTimer = null;
    }

    function renderCheckoutLoader(title) {
      renderCartPanel({
        kicker: 'One moment',
        title: title,
        text: '',
        actionsHtml:
          '<div class="returning-loader" role="status" aria-live="polite">' +
            '<span class="returning-loader-orb" aria-hidden="true"></span>' +
            '<div class="returning-loader-bar" aria-hidden="true"><span></span></div>' +
            '<p class="returning-loader-text">' + esc(CHECKOUT_LOADER_LINES[0]) + '</p>' +
            '<p class="returning-loader-note">Please keep this page open — it only takes a few seconds.</p>' +
          '</div>'
      });

      var index = 0;
      checkoutLoaderTimer = setInterval(function() {
        var actions = document.getElementById(activeCartPanelBase + '-actions');
        var line = actions && actions.querySelector('.returning-loader-text');
        if (!line) return;
        index = (index + 1) % CHECKOUT_LOADER_LINES.length;
        line.classList.add('is-fading');
        setTimeout(function() {
          line.textContent = CHECKOUT_LOADER_LINES[index];
          line.classList.remove('is-fading');
        }, 350);
      }, 1800);
    }

    function renderPayForDelivery(url, kicker, intro) {
      stopCheckoutTimers();
      renderCartPanel({
        kicker: kicker || 'One step left',
        title: 'Pay for delivery',
        text: intro || 'Your sizes are saved and your school pays for the uniform. You only pay for delivery — you will enter your address and phone number on the payment page. The phone number lets the delivery service reach you if there is a problem.',
        actionsHtml: '<a class="success-cart-btn hero" href="' + esc(url) + '">Pay for delivery</a>',
        showExtraSet: true
      });
    }

    function renderCheckoutLinkLate() {
      stopCheckoutTimers();
      renderCartPanel({
        kicker: 'Almost ready',
        title: 'Your payment link is on its way',
        text: 'We are still preparing it, and we have emailed it to you as well. Check your inbox (and spam) in a minute, or open this page again.',
        actionsHtml: '',
        showExtraSet: true
      });
    }

    /* options: notBefore (epoch seconds), title, kicker, intro */
    function waitForCheckoutLink(options) {
      options = options || {};
      stopCheckoutTimers();

      var token = resolveStudentToken();
      var started = Date.now();
      renderCheckoutLoader(options.title || 'Preparing your order');

      function attempt() {
        fetchCheckoutLink(token, options.notBefore).then(function(url) {
          var elapsed = Date.now() - started;

          if (url) {
            checkoutLinkTimer = setTimeout(function() {
              renderPayForDelivery(url, options.kicker, options.intro);
            }, Math.max(0, CHECKOUT_LINK_MIN_MS - elapsed));
            return;
          }

          if (elapsed >= CHECKOUT_LINK_WAIT_MS) {
            renderCheckoutLinkLate();
            return;
          }

          checkoutLinkTimer = setTimeout(attempt, CHECKOUT_LINK_POLL_MS);
        });
      }

      attempt();
    }

    /*
      ── The program-standing question, on Review (2026-10-07, owner) ──────

      Asked at the cart's checkout dialog until now (cohort-cart-customisations
      .liquid), which the uniform no longer passes. Same words; the dialog
      stays for ordinary shopping.

      Decided per chosen item by the product's own "Requires Midwestern
      Check" (owner, 2026-10-07), read from the school's products in the
      section's Liquid: True asks, False does not. A product whose box was
      never filled falls back to the name match, as the cart dialog does.

      2026-10-10 (owner) - no longer on the Review page. Submit Sizes opens
      it as a window of its own, and the order goes only after Yes and
      Confirm. Answered once per visit: a retry after a network error does
      not ask again. The answer is not sent anywhere - it gates the button,
      as it did on Review.
    */
    var standingConfirmed = false;

    function idListHas(list, id) {
      var needle = String(id || '').split('/').pop();
      if (!needle) return false;
      return (',' + String(list || '') + ',').indexOf(',' + needle + ',') !== -1;
    }

    function needsStandingCheck() {
      var school = ACTIVE_COHORT ? findSchoolByCode(ACTIVE_COHORT.schoolCode) : null;
      var askIds = (school && school.standingProductIds) || '';
      var skipIds = (school && school.noStandingProductIds) || '';
      var payload = collectPayload();

      return (payload.items || []).some(function(item) {
        if (idListHas(askIds, item.product_id)) return true;
        if (idListHas(skipIds, item.product_id)) return false;
        return String(item.product_title || '').toLowerCase().indexOf('midwestern') !== -1;
      });
    }

    function openStandingDialog(onConfirm) {
      var old = document.getElementById('standing-dialog');
      if (old) old.remove();

      var answer = '';
      var opener = document.activeElement;
      var overlay = document.createElement('div');
      overlay.id = 'standing-dialog';
      overlay.className = 'standing-dialog';
      overlay.innerHTML =
        '<div class="standing-dialog-card" role="dialog" aria-modal="true" aria-labelledby="standing-dialog-title" aria-describedby="standing-dialog-text">' +
          '<p class="standing-check-title" id="standing-dialog-title">Are you in good standing?</p>' +
          '<p class="standing-check-text" id="standing-dialog-text">Are you currently in good standing in your program?</p>' +
          '<div class="standing-check-options" role="group" aria-label="Good standing">' +
            '<button type="button" class="standing-check-option" data-standing="yes" aria-pressed="false">Yes</button>' +
            '<button type="button" class="standing-check-option" data-standing="no" aria-pressed="false">No</button>' +
          '</div>' +
          '<p class="standing-check-warning" hidden>Please make sure you are eligible to continue in the program before placing this order.</p>' +
          '<p class="standing-check-note">If you withdraw from the program for any reason, you will not be able to return your uniform. Please review our <a href="/policies/refund-policy" target="_blank" rel="noopener noreferrer">Return and Exchange Policy</a> before placing your order.</p>' +
          '<div class="standing-dialog-actions">' +
            '<button type="button" class="standing-dialog-back">Back</button>' +
            '<button type="button" class="standing-dialog-confirm" disabled>Confirm</button>' +
          '</div>' +
        '</div>';

      document.body.appendChild(overlay);
      var previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      var card = overlay.querySelector('.standing-dialog-card');
      var warning = overlay.querySelector('.standing-check-warning');
      var confirm = overlay.querySelector('.standing-dialog-confirm');

      function close() {
        document.removeEventListener('keydown', onKey);
        document.body.style.overflow = previousOverflow;
        overlay.remove();
        if (opener && opener.focus) opener.focus();
      }

      function onKey(event) {
        if (event.key === 'Escape') close();
      }

      overlay.querySelectorAll('[data-standing]').forEach(function(option) {
        option.addEventListener('click', function() {
          answer = option.getAttribute('data-standing');
          overlay.querySelectorAll('[data-standing]').forEach(function(other) {
            var on = other === option;
            other.classList.toggle('is-selected', on);
            other.setAttribute('aria-pressed', String(on));
          });
          warning.hidden = answer !== 'no';
          confirm.disabled = answer !== 'yes';
        });
      });

      overlay.querySelector('.standing-dialog-back').addEventListener('click', close);
      overlay.addEventListener('click', function(event) {
        if (event.target === overlay) close();
      });
      confirm.addEventListener('click', function() {
        if (answer !== 'yes') return;
        close();
        onConfirm();
      });
      document.addEventListener('keydown', onKey);

      var first = card.querySelector('[data-standing="yes"]');
      if (first) first.focus();
    }

    /*
      2026-08-16, edit B — which panel this draws into is no longer fixed.

      There are three of these panels and they belong to different screens:
      success-cart on the screen a student reaches by submitting, and
      already-submitted-cart / pending-cart on the screens a returning student
      lands on. All three carry the same five children under their own prefix.

      Drawing onto a screen the student is not looking at would leave them
      staring at the old wording, so the screen that opens sets the prefix.
    */
    var activeCartPanelBase = 'success-cart';

    function renderCartPanel(state) {
      var base = activeCartPanelBase;
      var panel = document.getElementById(base + '-panel');
      var kicker = document.getElementById(base + '-kicker');
      var title = document.getElementById(base + '-title');
      var text = document.getElementById(base + '-text');
      var actions = document.getElementById(base + '-actions');
      var extra = document.getElementById(base + '-extra');

      if (!panel || !kicker || !title || !text || !actions) return;

      kicker.textContent = state.kicker || '';
      title.textContent = state.title || '';
      text.textContent = state.text || '';
      actions.innerHTML = state.actionsHtml || '';

      /*
        Off unless the state asks for it.
      */
      if (state.showExtraSet) {
        renderExtraSetOffer(extra);
      } else {
        hideExtraSetOffer(extra);
      }

      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
    }

    /*
      2026-08-17 — one place that knows where the phone lives.

      It was on the shipping step as `phone` and is on step 1 as
      `student_phone`. Both names are read, older first-name-basis records and
      any half-deployed theme included, so a form served from a cached page
      still yields a number instead of an empty string.
    */
    function studentPhoneValue(form) {
      if (!form) return '';

      var field = form.student_phone || form.phone;
      return field ? String(field.value || '').trim() : '';
    }

    function showSuccess() {
      var form = document.getElementById('student-form');

      if (ACTIVE_COHORT && form && form.email) {
        markSubmissionCachedLocally(ACTIVE_COHORT.cohortCode, form.email.value || '');
      }

      var wizard = document.getElementById('student-wizard');
      var hero = document.querySelector('.student-hero');
      var success = document.getElementById('success-screen');
      var wrap = document.querySelector('.student-wrap');

      if (wrap) wrap.classList.add('is-success-view');

      var shell = document.querySelector('.student-shell');
      if (shell) shell.classList.add('is-success-active');

      wizard.style.display = 'none';
      hero.style.display = 'none';
      success.style.display = 'block';

      renderSuccessCopy();
      applyStudentStoreLink(ACTIVE_COHORT);
      /*
        Runs after the screen is on show, not before: the sizes are already
        saved by this point, so the payment link is the last errand rather
        than a condition of success.
      */
      if (studentPaysForDelivery()) {
        activeCartPanelBase = 'success-cart';
        waitForCheckoutLink({
          notBefore: lastSubmitStartedAt ? Math.floor(lastSubmitStartedAt / 1000) - 5 : 0,
          title: 'Preparing your order'
        });
      } else if (cohortShipsHome() && isDemoCohort()) {
        activeCartPanelBase = 'success-cart';
        renderCartPanel({
          kicker: 'Demo',
          title: 'Payment step skipped',
          text: 'In the live system the student pays for delivery here. In the demo this step is skipped.',
          actionsHtml: ''
        });
      }
      scrollToSuccessView();
      requestAnimationFrame(function() {
        scrollToSuccessView();
      });
    }

    /*
      Submission guard (2026-08-03). Deliberately its OWN storage key, not the
      admin pages' cohort_action_lock: only this page must ever block or prompt.
      The rest of the storefront does not load this script at all, so nothing
      else on the shop is affected.

      Why it exists: a refresh mid-submit aborts the request, and re-submitting
      afterwards used to race the first attempt — both writes land on the same
      student_entry (upsert by handle) and whichever finishes last wins, so the
      student could silently keep the wrong set of answers. The record carries
      its own expiry so a hung task can never strand the page.
    */
    var STUDENT_LOCK_KEY = 'cohort_student_action_lock';
    /*
      2026-08-06 — raised from 20s to outlast SUBMIT_CONFIRM_MS. The lock is what
      re-blocks the page after a manual refresh; expiring it mid-wait would hand
      the form back while the answers were still in flight.
    */
    var STUDENT_LOCK_MS = 50000;
    var studentAllowNextUnload = false;
    var studentLockReleaseTimer = null;

    function writeStudentLock() {
      try {
        window.localStorage.setItem(STUDENT_LOCK_KEY, JSON.stringify({
          cohortCode: normalizeCode(ACTIVE_COHORT && ACTIVE_COHORT.cohortCode),
          expiresAt: Date.now() + STUDENT_LOCK_MS
        }));
      } catch (error) {}
    }

    function readStudentLock() {
      var raw = null;

      try {
        raw = window.localStorage.getItem(STUDENT_LOCK_KEY);
      } catch (error) {
        return null;
      }

      if (!raw) return null;

      var parsed = null;

      try {
        parsed = JSON.parse(raw);
      } catch (error) {
        clearStudentLock();
        return null;
      }

      if (!parsed || !parsed.expiresAt || Date.now() >= parsed.expiresAt) {
        clearStudentLock();
        return null;
      }

      return parsed;
    }

    function clearStudentLock() {
      try {
        window.localStorage.removeItem(STUDENT_LOCK_KEY);
      } catch (error) {}

      if (studentLockReleaseTimer) {
        window.clearTimeout(studentLockReleaseTimer);
        studentLockReleaseTimer = null;
      }
    }

    function setStudentFormBlocked(active) {
      var shell = document.querySelector('.student-shell');
      var overlay = document.getElementById('student-submit-overlay');

      if (shell) shell.classList.toggle('is-submitting', !!active);

      if (overlay) {
        overlay.hidden = !active;
        overlay.setAttribute('aria-hidden', active ? 'false' : 'true');
      }
    }

    /*
      ── Waiting for the server, not for the webhook (2026-08-06) ──────────────

      A 200 from the Mechanic webhook means the request was accepted, nothing
      more: the task has not run yet, and an error it raises later never reaches
      this page. Showing the success screen on that 200 told students their
      sizes were saved when sometimes they were not.

      So after the POST we watch the server's own submission-lock list — the
      same list step one checks — until it shows this student as submitted.
      That flag is written by the task itself, so seeing it is real confirmation
      rather than our own optimism reflected back.

      Timing out is not failure: the answers usually did land and the task is
      merely slow. The student is told exactly that, and is NOT marked as
      submitted locally, so they can reopen the link and see the true state.
    */
    /* 30s → 45s (owner, 2026-08-06): the server was still finishing inside the
       old window often enough that students were shown the "taking longer"
       screen for submissions that had in fact landed. */
    var SUBMIT_CONFIRM_MS = 45000;
    var submitProgressTimer = null;

    function setSubmitOverlayCopy(title, note) {
      var titleEl = document.getElementById('student-submit-overlay-title');
      var noteEl = document.getElementById('student-submit-overlay-note');
      if (titleEl && title) titleEl.textContent = title;
      if (noteEl && note) noteEl.textContent = note;
    }

    function startSubmitProgress() {
      stopSubmitProgress();

      var bar = document.getElementById('student-submit-progress-bar');
      var startedAt = Date.now();

      if (bar) bar.style.width = '0%';

      submitProgressTimer = window.setInterval(function() {
        var elapsed = Date.now() - startedAt;
        /*
          Creeps to 95% and waits there. Filling to 100% before the server has
          answered would promise a finish this page cannot promise.
        */
        var ratio = Math.min(elapsed / SUBMIT_CONFIRM_MS, 1);
        if (bar) bar.style.width = Math.round(ratio * 95) + '%';

        if (elapsed > 8000) {
          setSubmitOverlayCopy('Still saving your answers', 'This is taking a little longer than usual. Please keep this page open.');
        }
      }, 300);
    }

    function stopSubmitProgress() {
      if (submitProgressTimer) {
        window.clearInterval(submitProgressTimer);
        submitProgressTimer = null;
      }
    }

    function wasRefusedAsTaken(cohortCode, email) {
      if (!STUDENT_SUBMIT_WEBHOOK_URL || !SUBMISSION_LOCKS_CACHE_URL) return Promise.resolve(false);

      return triggerSubmissionStatusCheck(buildStatusCheckPayload()).then(function() {
        return pollSubmissionFlags(cohortCode, email, { maxAttempts: 12, intervalMs: 700, initialDelayMs: 900 });
      }).then(function(flags) {
        return !!(flags && flags.taken);
      }).catch(function() {
        return false;
      });
    }

    function waitForSubmissionConfirmed(cohortCode, email) {
      if (!SUBMISSION_LOCKS_CACHE_URL) {
        /* Nothing to ask, so nothing can be confirmed — treat as not confirmed
           rather than inventing a success. */
        return Promise.resolve(false);
      }

      var deadline = Date.now() + SUBMIT_CONFIRM_MS;
      /* Short at first because most runs finish quickly, then longer so a slow
         task is not hammered with requests for half a minute. */
      var delays = [900, 1500, 2500, 3500, 4500, 5500, 6000];
      var attempt = 0;

      function poll() {
        if (Date.now() >= deadline) return Promise.resolve(false);

        return fetchSubmissionState().then(function(state) {
          if (isSubmissionLockedInList(state.locks, cohortCode, email)) {
            return true;
          }

          var wait = delays[Math.min(attempt, delays.length - 1)];
          attempt += 1;

          if (Date.now() + wait >= deadline) return false;

          return waitMs(wait).then(poll);
        }).catch(function() {
          var wait = delays[Math.min(attempt, delays.length - 1)];
          attempt += 1;

          if (Date.now() + wait >= deadline) return false;

          return waitMs(wait).then(poll);
        });
      }

      return waitMs(700).then(poll);
    }

    function beginStudentSubmitLock() {
      writeStudentLock();
      setStudentFormBlocked(true);
      setSubmitOverlayCopy('Saving your answers', 'Please keep this page open until it finishes. Do not refresh or close the tab.');
      startSubmitProgress();
    }

    function endStudentSubmitLock() {
      stopSubmitProgress();
      clearStudentLock();
      setStudentFormBlocked(false);
    }

    /* Re-block after a manual refresh, for whatever is left of the window. */
    function restoreStudentLock() {
      var lock = readStudentLock();
      if (!lock) return;

      var remaining = lock.expiresAt - Date.now();
      if (remaining <= 0) {
        clearStudentLock();
        return;
      }

      setStudentFormBlocked(true);
      studentLockReleaseTimer = window.setTimeout(endStudentSubmitLock, remaining);
    }

    function bindStudentUnloadGuard() {
      window.addEventListener('beforeunload', function(event) {
        if (studentAllowNextUnload) {
          studentAllowNextUnload = false;
          return;
        }

        if (!readStudentLock()) return;

        event.preventDefault();
        /* Legacy browsers need returnValue set; the text is browser-controlled. */
        event.returnValue = '';
        return '';
      });
    }

    function postSubmission(url, payload) {
      var body = JSON.stringify(payload);
      var init = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: body
      };

      /* Small body, so let it survive the page going away if it can. */
      try {
        if (new Blob([body]).size <= 50000) init.keepalive = true;
      } catch (error) {}

      /*
        The catch sits directly on fetch, before any response handling, so it
        can only be a transport failure — no reply came back. Anything the
        server did answer, including an error, is handled below and keeps its
        own wording.
      */
      return fetch(url, init).catch(function() {
        throw new Error(NETWORK_ERROR);
      }).then(function(response) {
        return response.text().then(function(text) {
          var data = {};

          try {
            data = text ? JSON.parse(text) : {};
          } catch (error) {
            data = { raw: text || '' };
          }

          if (!response.ok) {
            throw new Error((data && (data.error || data.message)) || text || ('HTTP ' + response.status));
          }

          if (data && data.ok === false) {
            throw new Error(data.error || data.message || 'Submission failed');
          }

          return data;
        });
      });
    }

    function bindWizard() {
      var form = document.getElementById('student-form');
      var emailField = form.email;
      var wizard = document.getElementById('student-wizard');

      if (wizard && !wizard.dataset.navBound) {
        wizard.dataset.navBound = '1';
        wizard.addEventListener('click', function(event) {
          if (event.target.closest('#next-btn')) {
            event.preventDefault();
            attemptAdvanceFromCurrentStep();
          }
        });
      }

      document.getElementById('back-btn').addEventListener('click', function() {
        goToStep(getPreviousStep(currentStep));
      });

      emailField.addEventListener('input', function() {
        emailNoticeRequestId += 1;
        hideAlreadySubmittedNotice();
        hideEmailRosterHintNotice();
        clearTimeout(rosterHintDebounceTimer);

        if (!emailField.value) {
          hideEmailErrorNotice();
          syncStepOneContinueButton();
          return;
        }
        updateEmailValidationUI();
        syncStepOneContinueButton();

        var normalizedInputEmail = normalizeEmail(emailField.value || '');
        if (isValidEmail(normalizedInputEmail)) {
          rosterHintDebounceTimer = setTimeout(function() {
            refreshEmailNoticesForCurrentEmail();
          }, 400);
        }
      });

      emailField.addEventListener('blur', function() {
        if (!emailField.value) {
          hideEmailRosterHintNotice();
          return;
        }

        if (updateEmailValidationUI()) {
          refreshEmailNoticesForCurrentEmail();
        } else {
          hideEmailRosterHintNotice();
        }
      });

      document.getElementById('student-form').addEventListener('submit', function(event) {
        event.preventDefault();

        var button = document.getElementById('submit-btn');
        var message = document.getElementById('student-status');

        if (!validateStep(1) || !validateStep(3)) {
          return;
        }

        if (!STUDENT_SUBMIT_WEBHOOK_URL) {
          message.textContent = 'Student submit webhook URL is missing.';
          return;
        }

        if (needsStandingCheck() && !standingConfirmed) {
          openStandingDialog(function() {
            standingConfirmed = true;
            var form = document.getElementById('student-form');
            if (form.requestSubmit) form.requestSubmit();
            else form.dispatchEvent(new Event('submit', { cancelable: true }));
          });
          return;
        }

        lastSubmitStartedAt = Date.now();
        button.disabled = true;
        button.textContent = 'Submitting...';
        message.textContent = '';
        beginStudentSubmitLock();

        var submitCohortCode = ACTIVE_COHORT.cohortCode;
        var submitEmail = document.getElementById('student-form').email.value || '';

        /*
          Second check, deliberately here and not only on step one. Step one
          gives up waiting after 2.2s and lets the student through — the right
          call, since blocking someone who has not submitted is worse than
          letting a repeat through. But then this is the last chance to catch
          them before a pointless POST that the task will refuse in silence.
          A refusal that never reaches the browser has to be pre-empted here.
        */
        isEmailSubmissionLocked(submitCohortCode, submitEmail)
          .catch(function() { return false; })
          .then(function(alreadyLocked) {
            if (alreadyLocked) {
              endStudentSubmitLock();
              renderAlreadySubmittedNotice('Contact your school admin if you need changes.');
              return 'skipped';
            }

            return postSubmission(STUDENT_SUBMIT_WEBHOOK_URL, collectPayload()).then(function() {
              /*
                The overlay deliberately stays up here. showSuccess() marks the
                student as submitted in this browser, so it must not run until
                the server agrees — otherwise a failed task would leave them
                locked out of a form they never actually completed.
              */
              return waitForSubmissionConfirmed(submitCohortCode, submitEmail);
            });
          })
          .then(function(result) {
            if (result === 'skipped') return;

            if (result) {
              endStudentSubmitLock();
              hideEmailErrorNotice();
              showSuccess();
              return;
            }

            /*
              2026-10-17 (owner) - not confirmed in time. Before saying "taking
              longer", ask the question the server's quiet refusal answers: is
              this address another student's? The status check records that
              (the taken list); the submission itself cannot tell the page.
              Yes - the answers were NOT saved, and the student is told so,
              back on step 1. Anything else - the usual pending screen.
            */
            return wasRefusedAsTaken(submitCohortCode, submitEmail).then(function(taken) {
              endStudentSubmitLock();

              if (taken) {
                goToStep(1);
                renderEmailTakenNotice('Your answers were not saved.', 'This email belongs to another student of this cohort. Enter your own email, or open the link from your own email.');
                message.textContent = 'Not saved: this email belongs to another student.';
                button.disabled = false;
                button.textContent = 'Submit Sizes';
                return;
              }

              hideEmailErrorNotice();
              showStudentStateScreen('submission-pending-screen');
            });
          })
          .catch(function(error) {
            var errorMessage = error && error.message ? error.message : 'Error submitting. Please try again.';

            /*
              A lost connection is not an answer, so do not give one yet. The
              request may have arrived and run while the reply went missing —
              ask the server what actually happened, exactly as the successful
              path does, and only then say something.

              The submit lock deliberately stays on while this runs: releasing
              it would invite a second submission for a form that may already
              be saved.
            */
            if (errorMessage === NETWORK_ERROR) {
              return waitForSubmissionConfirmed(submitCohortCode, submitEmail)
                .catch(function() { return false; })
                .then(function(landedAnyway) {
                  endStudentSubmitLock();

                  if (landedAnyway) {
                    hideEmailErrorNotice();
                    showSuccess();
                    return;
                  }

                  message.textContent = NETWORK_ERROR_MESSAGE;
                  button.disabled = false;
                  button.textContent = 'Submit Sizes';
                });
            }

            endStudentSubmitLock();
            /* 2026-10-06 - no address step to send an address error to. */
            message.textContent = errorMessage;

            if (isAlreadySubmittedError(errorMessage)) {
              renderAlreadySubmittedNotice('Contact your school admin if you need changes.');
              goToStep(1);
            } else if (/not open|deadline|finalized/i.test(errorMessage)) {
              goToStep(1);
            } else if (/email/i.test(errorMessage)) {
              renderEmailErrorNotice(errorMessage);
              goToStep(1);
            }

            button.disabled = false;
            button.textContent = 'Submit Sizes';
          });
      });
    }

    function bindStudentStateScreenButtons() {
      /*
        The pending screen is a conclusion this page cannot be certain of: a
        slow task finishes eventually, and a plain reload re-runs every check
        against the server rather than leaving the student on a guess.

        The already-submitted screen used to be bound here too. It lost its
        reload button on 2026-08-20 — the panel under it now says what the
        server actually knows, which is a better answer than trying again.
      */
      var button = document.getElementById('submission-pending-reload');
      if (!button) return;

      button.addEventListener('click', function() {
        studentAllowNextUnload = true;
        clearStudentLock();
        window.location.reload();
      });
    }

    function init() {
      bindStudentUnloadGuard();
      bindStudentStateScreenButtons();
      restoreStudentLock();

      var params = new URLSearchParams(window.location.search);
      var code = params.get('cohort') || params.get('code') || params.get('cohort_code');

      URL_TOKEN = params.get('token') || '';

      if (!code) {
        showInvalid('Missing cohort code in URL', 'This link is invalid or incomplete.');
        return;
      }

      var cohort = findEmbeddedCohort(code);

      if (!cohort || !cohort.cohortCode) {
        /*
          2026-08-07 — say enough to tell the two causes apart without opening
          the page source.

          "Not found" has meant two very different things: the cohort list was
          truncated by Shopify so the record never reached the page, or the
          code in the link does not match any cohort. The counts settle it — a
          list that arrived with entries but not this one is a wrong code; a
          list that is suspiciously short is the truncation, which is what the
          direct lookup above exists to defeat.
        */
        var embeddedCount = Array.isArray(EMBEDDED_COHORTS) ? EMBEDDED_COHORTS.length : 0;
        var firstCodes = (Array.isArray(EMBEDDED_COHORTS) ? EMBEDDED_COHORTS : [])
          .slice(0, 3)
          .map(function(entry) { return entry && entry.cohortCode; })
          .join(', ');

        showInvalid(
          'Cohort not found in embedded data — looking for "' + code + '", page received ' +
            embeddedCount + ' cohort(s)' + (firstCodes ? ' (' + firstCodes + '…)' : ''),
          'This link is invalid or the form is closed.'
        );
        return;
      }

      cohort = applyLateResubmitOverride(cohort, URL_TOKEN);

      /*
        ── 2026-08-20 — one door, and it asks one question (owner) ──────────

        Every visitor now starts here, whichever link brought them: the general
        one a school hands out, or a personal one from a letter. They give
        their address and the page finds out what it means, then sends them
        where they belong — the form if they have not answered it, their own
        order if they have.

        Why it matters more than tidiness: at the school this was built for our
        letters do not arrive, so the general link has to be enough. They type
        the address they gave their school and get their payment link, with no
        admin and no email in the middle.
      */
      ACTIVE_COHORT = cohort;
      initParams = params;
      applyStudentStoreLink(ACTIVE_COHORT);
      startStepZero();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
